import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { USER_API } from "../../common/common";
import { Logout } from "../../common/Funcation";
import Loader from "../../components/Loader";
import NewsLine from "../../components/NewsLine";
import { notifyError, notifyMessage, postApi } from "../../service";
import LoaderImage from "../../assets/images/loaderajaxbet.gif";
import CricketImage from "../../assets/images/cricket-m.jpeg";

import YoutubeImage from "../../assets/images/casino-icon/youtube.png";
import FImage from "../../assets/images/casino-icon/f.png";
import BImage from "../../assets/images/casino-icon/b.png";
import SImage from "../../assets/images/casino-icon/s.png";
import CricketBall from "../../assets/images/icon-cricket.svg";
import Streaming from "../../assets/images/streaming.svg";
import fancybet from "../../assets/images/fancybet.svg";
import bookmaker from "../../assets/images/bookmaker.svg";

import { ReactComponent as chartSvg } from "../../assets/images/chart.svg";
import BottomFooter from "../../components/BottomFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faCircleCheck,
  faFile,
  faGear,
  faList,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import Leagues from "../Inplay/Leagues";
import chipIcon from "../../assets/images/casino-icon/chip.webp";
import CommonPopup from "../../components/CommonPopup";
import NewsLinePopup from "../../components/NewsLinePopup";
import Footer from '../../components/Footer';
import FooterComponent from "../../components/FooterComponent";
import WelcomePopup from "../WelcomePopup";
import Slider from "react-slick";
import { isMobile } from "react-device-detect";
const cookies = new Cookies();

const Cricket = () => {
  const navigate = useNavigate();

  const matchCount = useSelector((e) => e.matchCount);
  const DD = useSelector((e) => e.domainDetails);
  const [newsPopup, setNewsPopup] = useState(false);

  const inPlayDetail = useSelector((e) =>
    e.inPlayDetail ? e.inPlayDetail : undefined
  );
  console.log("inPlayDetail :::: ", inPlayDetail);
  const [pageData, setPageData] = useState(
    inPlayDetail?.inPlay ? inPlayDetail?.inPlay : {}
  );
  const [tabUp, setTabUp] = useState("play");
  const [tab, setTab] = useState("play");
  const [cricketToggle, setCricketToggle] = useState(false);
  const [soccerToggle, setSoccerToggle] = useState(false);
  const [tennisToggle, setTennisToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [isLoadingMain, setIsLoadingMain] = useState(false);
  const [allTurnaments, setAllTurnaments] = useState();
  const sportsData = localStorage.getItem("isSignUpLogin");

  const [allDropDownOption, setAllDropDownOption] = useState([
    "by Competition",
    "by Time",
    // "by Matched",
  ]);
  const [dropDownOption, setDropDownOption] = useState("by Competition");

  useEffect(() => {
    document.documentElement.style.setProperty("--content-bg", `#f0ece1`);
  }, []);

  const [openDropdown, setOpenDropdown] = useState(false);
  const [categoryState, setCategoryState] = useState({
    cricket: false,
    soccer: false,
    tennis: false,
  });

  useEffect(() => {
    setIsLoadingMain(true);
    getPageData("play");
    setTimeout(() => {
      dispatch({ type: "GET_SPORTS_DETAILS", payload: {} });
    }, 1000);
    return () => { };
  }, []);

  useEffect(() => {
    if (JSON.stringify(inPlayDetail) !== "{}" && inPlayDetail !== undefined) {
      // setIsLoadingMain(false)
      setPageData(
        tab === "play"
          ? inPlayDetail?.inPlay
          : tab === "today"
            ? inPlayDetail?.today
            : tab === "tomorrow"
              ? inPlayDetail?.tomorrow
              : {}
      );
    }
  }, [inPlayDetail]);

  const getScoreBoardId = async (gameId) => {
    let data = {
      api: USER_API.GET_SCORE_BOARD,
      value: { gameId },
    };

    await postApi(data)
      .then(function (response) {
        if (response?.data?.data?.scoreIdInfo?.result) {
          console.log("GET_SCORE_BOARD", response?.data?.data);
          if (response?.data?.data?.scoreIdInfo?.result?.length > 0) {
            // setActiveAccordionsChartIds({
            //     ...activeAccordionsChartIds, [gameId] : response?.data?.data?.scoreIdInfo?.result[0].score_id
            // })
            setActiveAccordionsChartIds((prevAccordions) =>
              prevAccordions[gameId]
                ? { ...prevAccordions }
                : {
                  ...prevAccordions,
                  [gameId]:
                    response?.data?.data?.scoreIdInfo?.result[0].score_id,
                }
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };
  const getPageData = async (FILTER) => {
    setIsLoadingMain(true);

    let data = {
      api: USER_API.IN_PLAY,
      value: { filter: FILTER },
    };

    await postApi(data)
      .then(function (response) {
        console.log("response :::: ", response);
        setPageData(response.data.data);
        let uniqueTurnaments = [];
        if (response?.data?.data) {
          for (const category in response?.data?.data) {
            const categoryData = response?.data?.data[category];
            const turnamentArray = categoryData.map((item) => item.Turnament);
            uniqueTurnaments[category] = [...new Set(turnamentArray)];
          }

          setAllTurnaments(uniqueTurnaments);

          let data = { ...uniqueTurnaments };
          console.log("data", data);

          const result = Object.entries(data) // Get an array of key-value pairs
            .flatMap(([category, values]) => {
              // Destructure each entry into category and values
              return values.slice(0, 1).map((value) => `${category}_${value}`); // Concatenate category name with each value
            });

          setActiveAccordions(result);
        }

        if (FILTER === "play") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_IN_PLAY",
            payload: response.data.data,
          });
        } else if (FILTER === "today") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TODAY",
            payload: response.data.data,
          });
        } else if (FILTER === "tomorrow") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TOMORROW",
            payload: response.data.data,
          });
        } else {
          dispatch({ type: "SET_IN_PLAY_DETAILS", payload: undefined });
        }
        setIsLoading(false);
        setIsLoadingMain(false);
      })
      .catch((err) => {
        setIsLoadingMain(false);
        setIsLoading(false);
        console.log(err);
        if (err.response.data.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  const toggleCategory = (category) => {
    let data = { ...allTurnaments };
    if (categoryState[category]) {
      setCategoryState({ ...categoryState, [category]: false });
      return activeAccordions?.filter(
        (value) => !value.startsWith(`${category}_`)
      );
    } else {
      setCategoryState({ ...categoryState, [category]: true });
      let newdata = [
        ...activeAccordions,
        ...data[category].map((value) => `${category}_${value}`),
      ];
      return Array.from(new Set(newdata));
    }
  };

  const handleClick = (category) => {
    const result = toggleCategory(category);
    setActiveAccordions(result);
  };

  const changeTab = (TAB) => {
    setIsLoadingMain(true);
    if (TAB === "play") {
      setPageData(inPlayDetail?.inPlay);
      setIsLoadingMain(false);
    } else if (TAB === "today") {
      setPageData(inPlayDetail?.today);
      setIsLoadingMain(false);
    } else if (TAB === "tomorrow") {
      setPageData(inPlayDetail?.tomorrow);
      setIsLoadingMain(false);
    }
    getPageData(TAB);
    setTab(TAB);
    setCricketToggle(false);
    setSoccerToggle(false);
    setTennisToggle(false);
  };

  //new code

  const [activeAccordions, setActiveAccordions] = useState();
  const [activeAccordionsChart, setActiveAccordionsChart] = useState([]);
  const [activeAccordionsChartIds, setActiveAccordionsChartIds] = useState({});
  const [parlyActive, setParlyActive] = useState(false);
  const [categoryActive, setcategoryActive] = useState("all");
  const [searchActive, setSearchActive] = useState(false);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const category = params.get("category");

  useEffect(() => {
    if (category?.length) {
      setcategoryActive(category);
    }
  }, [category]);

  useEffect(() => {
    let data = { ...allTurnaments };
    if (categoryActive !== "all") {
      const result = Object.entries(data) // Get an array of key-value pairs
        .flatMap(([category, values]) => {
          // Destructure each entry into category and values
          return values.map((value) => `${category}_${value}`); // Concatenate category name with each value
        });
      setActiveAccordions(result);
      setCategoryState({
        cricket: true,
        soccer: true,
        tennis: true,
      });
    } else {
      const result = Object.entries(data) // Get an array of key-value pairs
        .flatMap(([category, values]) => {
          // Destructure each entry into category and values
          return values.slice(0, 1).map((value) => `${category}_${value}`); // Concatenate category name with each value
        });

      setActiveAccordions(result);
      setCategoryState({
        cricket: false,
        soccer: false,
        tennis: false,
      });
    }
  }, [categoryActive]);

  const toggleAccordion = (id) => {
    setActiveAccordions((prevAccordions) =>
      prevAccordions.includes(id)
        ? prevAccordions.filter((accordionId) => accordionId !== id)
        : [...prevAccordions, id]
    );
  };

  // Custom comparator function to sort undefined values to last
  const customSort = (a, b) => {
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a - b; // Adjust this line based on your sorting criteria
  };

  const openDetailPage = (item) => {
    localStorage.setItem("sportsName", item.eventName);
    localStorage.setItem("sportsData", JSON.stringify(item));
    navigate(`/multimarket/${item.gameId}/${item.marketId}`);
  };

  const clickOnScoreBoard = (e, id) => {
    e.stopPropagation();
    setActiveAccordionsChart((prevAccordions) =>
      prevAccordions.includes(id)
        ? prevAccordions.filter((accordionId) => accordionId !== id)
        : [...prevAccordions, id]
    );
    console.log("activeAccordionsChartIds ::: ", activeAccordionsChartIds);
    const gameId = Number(id.split("_")[1]);
    if (!activeAccordionsChartIds[gameId]) {
      getScoreBoardId(gameId);
    }
  };
  const isAuthenticated = useSelector((e) => e.isAuthenticated);
  const [mybet, setMybet] = useState(false);
  const handleBetPopup = () => {

    if (isAuthenticated) {
      setMybet(true)
    }
    else {
      window.location.href = '/login'
    }
  }
   var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getCasinoLink = async (fromMobile = false) => {
      if (cookies.get("skyTokenFront")) {
        let data = {
          api: USER_API.CASINO_LOGIN,
          value: {
            id: "loginType",
            isMobileLogin: isMobile ? true : false,
            domain:
              window.location.hostname === "localhost"
                ? "taka365.win"
                : window.location.hostname,
          },
          token: cookies.get("skyTokenFront") ? cookies.get("skyTokenFront") : "",
        };
  
        await postApi(data)
          .then(function (response) {
            window.open(response?.data?.data?.url, "_blank");
          })
          .catch((err) => {
            console.log(err);
            notifyError(err?.response?.data?.message);
  
            if (err.response.data.statusCode === 401) {
              Logout();
              // notifyError('Pin unsuccess')
              // navigate('/login')
            }
          });
      } else {
        if (fromMobile) {
          window.location.pathname = "/login";
        }
        notifyError("please login first");
      }
    };
  return (
    <>
      {sportsData && sportsData === "true" && <WelcomePopup />}
      {console.log("activeAccordions", activeAccordions)}
      <div className="full-wrap bottomfooter sports 00">
        <div className="home-banner-slider">
          <Slider {...settings}>
          <div>
            <img src="https://baajiwala.live/assets/images/bannerl3.webp" alt="Banner" />
          </div>
          <div>
            <img src="https://baajiwala.live/assets/images/bannerl5.webp" alt="Banner" />
          </div>
          <div>
            <img src="https://baajiwala.live/assets/images/bannerl2.webp" alt="Banner" />
          </div>
        </Slider>
        </div>
        <div className="parlay-tab">
          <form className="d-flex align-items-center">
            <div className="parlay-checkbox">
              {/* <div className="parly-check form-switch" >
                                <input type="checkbox" id='parly' checked={parlyActive} onClick={(e) => setParlyActive(e?.target?.checked)} />
                                <label htmlFor="parly"></label>
                            </div>
                            <span >Parlay</span> */}
            </div>
            <div className="parlay-inner-tab d-flex align-items-center">
              <div>
                <ul className="mb-0 p-0">
                  <li
                    className={`${tabUp === "play" ? "active" : ""} `}
                    onClick={() => {
                      changeTab("play");
                      setTabUp("play");
                      setParlyActive(false);
                    }}
                  >
                    Live
                  </li>
                  <li
                    className={`${tabUp === "Upcoming" ? "active" : ""} `}
                    onClick={() => {
                      changeTab("today");
                      setTabUp("Upcoming");
                      setParlyActive(false);
                    }}
                  >
                    Upcoming
                  </li>
                  <li
                    className={`${tabUp === "Leagues" ? "active" : ""} `}
                    onClick={() => {
                      setTabUp("Leagues");
                      setParlyActive(false);
                    }}
                  >
                    Leagues
                  </li>
                  <li
                    className={`${tabUp === "Parlay" ? "active" : ""} `}
                    onClick={() => {
                      setTabUp("Parlay");
                      setParlyActive(true);
                    }}
                  >
                    Parlay
                  </li>
                  {/* <li className={`${tab === 'today' ? 'active' : ''} `} onClick={() => changeTab('today')}>Today</li>
                                    <li className={`${tab === 'tomorrow' ? 'active' : ''} `} onClick={() => changeTab('tomorrow')}>Tomorrow</li> */}
                  <li className="only_mobile ms-auto mb-0">
                    <FontAwesomeIcon icon={faSearch} />
                  </li>
                  <li className="only_mobile mb-0" onClick={() => setNewsPopup(true)}>
                    <FontAwesomeIcon icon={faBell} />
                  </li>
                  <li className="only_mobile ">
                    <FontAwesomeIcon icon={faGear} />
                  </li>
                </ul>
              </div>
              <div className="parlay-icons">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 1024 1024"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
                </svg>
                <svg
                  onClick={() => setSearchActive(true)}
                  stroke="currentColor"
                  fill="none"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="ms-auto"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
            </div>
          </form>
        </div>

        {searchActive && (
          <div className="search-games-sec">
            <form className="">
              <div className="position-relative">
                <input
                  placeholder="Search platform, games, and more......"
                  type="text"
                  className="form-control"
                  value=""
                />
                <button
                  type="button"
                  className="bg-transparent border-0 text-dark position-absolute end-0 top-0 pt-0 fs-4 btn btn-primary"
                  onClick={() => setSearchActive(false)}
                >
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="0"
                    viewBox="0 0 15 15"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="search-listing mt-sm-3 ">
                <ul className="p-0 m-0">
                  <div className="w-100 mb-3 match-list">
                    {false ? (
                      <div className="no-event-outer">
                        <div className="no-event">
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 24 24"
                            color="lightgrey"
                            className="mb-2"
                            height="55"
                            width="55"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ color: "lightgrey;" }}
                          >
                            <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                          </svg>
                          No Event
                        </div>
                      </div>
                    ) : (
                      <ul className="p-0">
                        <li>The Greatest Cards Show</li>
                        <li>Triple Card Poker</li>
                      </ul>
                    )}
                  </div>
                </ul>
              </div>
            </form>
          </div>
        )}

        <div className="game-menu">
          <ul className="p-0 mb-0">
            <li className="" onClick={() => getCasinoLink()}>
              <div>
                <img
                  class="main-img"
                  src={chipIcon}
                  alt="Icon"
                  style={{ width: "16px" }}
                ></img>
              </div>
              Casino
            </li>
            <li className="">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                </svg>
              </div>
              My Fav
            </li>
            <li
              className={`${categoryActive === "all" ? "active" : ""}`}
              onClick={() => setcategoryActive("all")}
            >
              <div>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 1024 1024"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z"></path>
                </svg>
              </div>
              All
              <span className="count position-absolute">{
                tabUp === "play" ?
                  (matchCount?.inPlay?.all || '5') :
                  tab === "today" ?
                    (matchCount?.today?.all || '7') :
                    tab === "tomorrow" ?
                      (matchCount?.tomorrow?.all || 10) : '12'}
              </span>
            </li>
            <li
              className={`${categoryActive === "cricket" ? "active" : ""}`}
              onClick={() => setcategoryActive("cricket")}
            >
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.0"
                  viewBox="0 0 93.000000 96.000000"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <g
                    transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
                    stroke="currentColor"
                    fill="currentColor"
                  >
                    <path d="M352 913 c-13 -3 -22 -9 -20 -15 2 -5 116 -147 253 -314 169 -206 251 -300 257 -291 5 6 18 43 29 81 68 219 -58 452 -287 530 -45 15 -173 20 -232 9z" />
                    <path d="M208 846 c-10 -7 -18 -16 -18 -20 0 -4 122 -155 271 -337 l271 -330 24 22 23 21 -79 97 c-379 462 -456 555 -465 557 -5 2 -18 -3 -27 -10z" />
                    <path d="M80 698 c-40 -71 -54 -138 -48 -239 7 -137 71 -249 185 -325 85 -56 161 -77 263 -71 82 4 174 31 168 48 -6 18 -520 639 -528 639 -5 0 -23 -24 -40 -52z" />
                  </g>
                </svg>
              </div>
              Cricket
              <span className="count position-absolute">{
                tabUp === "play" ?
                  (matchCount?.inPlay?.cricket || '2') :
                  tab === "today" ?
                    (matchCount?.today?.cricket || '5') :
                    tab === "tomorrow" ?
                      (matchCount?.tomorrow?.cricket || 4) : '4'}
              </span>
            </li>
            <li
              className={`${categoryActive === "soccer" ? "active" : ""}`}
              onClick={() => setcategoryActive("soccer")}
            >
              <div>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 512 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M255.03 33.813c-1.834-.007-3.664-.007-5.5.03-6.73.14-13.462.605-20.155 1.344.333.166.544.32.47.438L204.78 75.063l73.907 49.437-.125.188 70.625.28L371 79.282 342.844 52c-15.866-6.796-32.493-11.776-49.47-14.78-12.65-2.24-25.497-3.36-38.343-3.407zM190.907 88.25l-73.656 36.78-13.813 98.407 51.344 33.657 94.345-43.438 14.875-76.5-73.094-48.906zm196.344.344l-21.25 44.5 36.75 72.72 62.063 38.905 11.312-21.282c.225.143.45.403.656.75-.77-4.954-1.71-9.893-2.81-14.782-6.446-28.59-18.59-55.962-35.5-79.97-9.07-12.872-19.526-24.778-31.095-35.5l-20.125-5.342zm-302.656 23c-6.906 8.045-13.257 16.56-18.938 25.5-15.676 24.664-26.44 52.494-31.437 81.312C31.783 232.446 30.714 246.73 31 261l20.25 5.094 33.03-40.5L98.75 122.53l-14.156-10.936zm312.719 112.844l-55.813 44.75-3.47 101.093 39.626 21.126 77.188-49.594 4.406-78.75-.094.157-61.844-38.783zm-140.844 6.406l-94.033 43.312-1.218 76.625 89.155 57.376 68.938-36.437 3.437-101.75-66.28-39.126zm-224.22 49.75c.91 8.436 2.29 16.816 4.156 25.094 6.445 28.59 18.62 55.96 35.532 79.968 3.873 5.5 8.02 10.805 12.374 15.938l-9.374-48.156.124-.032-27.03-68.844-15.782-3.968zm117.188 84.844l-51.532 8.156 10.125 52.094c8.577 7.49 17.707 14.332 27.314 20.437 14.612 9.287 30.332 16.88 46.687 22.594l62.626-13.69-4.344-31.124-90.875-58.47zm302.437.5l-64.22 41.25-42 47.375 4.408 6.156c12.027-5.545 23.57-12.144 34.406-19.72 23.97-16.76 44.604-38.304 60.28-62.97 2.51-3.947 4.87-7.99 7.125-12.092zm-122.78 97.656l-79.94 9.625-25.968 5.655c26.993 4 54.717 3.044 81.313-2.813 9.412-2.072 18.684-4.79 27.75-8.062l-3.156-4.406z"></path>
                </svg>
              </div>
              Soccer
              <span className="count position-absolute">{
                tabUp === "play" ?
                  (matchCount?.inPlay?.soccer || '2') :
                  tab === "today" ?
                    (matchCount?.today?.soccer || '5') :
                    tab === "tomorrow" ?
                      (matchCount?.tomorrow?.soccer || 4) : '4'}
              </span>
            </li>
            <li
              className={`${categoryActive === "tennis" ? "active" : ""}`}
              onClick={() => setcategoryActive("tennis")}
            >
              <div>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 512 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M246.938 35.188c-25.875 1.07-51.58 6.686-75.5 16.593-26.714 11.065-51.274 27.462-71.72 47.907-20.445 20.446-36.84 45.005-47.906 71.72-9.8 23.662-15.405 49.065-16.562 74.655 74.49-11.465 126.867-33.367 160.656-67.156 33.846-33.845 50.15-80.167 51.03-143.72zm18 0c-.91 66.75-18.61 118.764-56.313 156.468-38.05 38.05-95.324 60.96-173.438 72.625 1 26.133 6.65 52.13 16.657 76.283 11.067 26.715 27.458 51.24 47.906 71.687 20.448 20.448 45.003 36.87 71.72 47.938 24.152 10.005 50.122 15.63 76.25 16.625 11.665-78.115 34.575-135.39 72.624-173.438 37.704-37.704 89.72-55.402 156.47-56.313-1.06-25.916-6.67-51.663-16.595-75.625-11.068-26.715-27.49-51.27-47.94-71.718-20.447-20.45-44.97-36.84-71.686-47.907-23.96-9.927-49.735-15.56-75.656-16.626zm211.187 229.875c-63.202.987-109.34 17.307-143.063 51.03-33.793 33.795-55.662 86.15-67.125 160.657 25.596-1.157 51.026-6.762 74.688-16.563 26.714-11.064 51.242-27.46 71.688-47.906 20.445-20.444 36.842-44.972 47.906-71.686 9.906-23.922 15.522-49.652 16.592-75.53-.228.002-.46-.005-.687-.002z"></path>
                </svg>
              </div>
              Tennis
              <span className="count position-absolute">{
                tabUp === "play" ?
                  (matchCount?.inPlay?.tennis || '2') :
                  tab === "today" ?
                    (matchCount?.today?.tennis || '5') :
                    tab === "tomorrow" ?
                      (matchCount?.tomorrow?.tennis || 4) : '4'}
              </span>
            </li>
            {/* <li className={`${categoryActive === 'Virtual' ? 'active' : ''}`} onClick={() => setcategoryActive('Virtual')}>
                            <div>
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M255.03 33.813c-1.834-.007-3.664-.007-5.5.03-6.73.14-13.462.605-20.155 1.344.333.166.544.32.47.438L204.78 75.063l73.907 49.437-.125.188 70.625.28L371 79.282 342.844 52c-15.866-6.796-32.493-11.776-49.47-14.78-12.65-2.24-25.497-3.36-38.343-3.407zM190.907 88.25l-73.656 36.78-13.813 98.407 51.344 33.657 94.345-43.438 14.875-76.5-73.094-48.906zm196.344.344l-21.25 44.5 36.75 72.72 62.063 38.905 11.312-21.282c.225.143.45.403.656.75-.77-4.954-1.71-9.893-2.81-14.782-6.446-28.59-18.59-55.962-35.5-79.97-9.07-12.872-19.526-24.778-31.095-35.5l-20.125-5.342zm-302.656 23c-6.906 8.045-13.257 16.56-18.938 25.5-15.676 24.664-26.44 52.494-31.437 81.312C31.783 232.446 30.714 246.73 31 261l20.25 5.094 33.03-40.5L98.75 122.53l-14.156-10.936zm312.719 112.844l-55.813 44.75-3.47 101.093 39.626 21.126 77.188-49.594 4.406-78.75-.094.157-61.844-38.783zm-140.844 6.406l-94.033 43.312-1.218 76.625 89.155 57.376 68.938-36.437 3.437-101.75-66.28-39.126zm-224.22 49.75c.91 8.436 2.29 16.816 4.156 25.094 6.445 28.59 18.62 55.96 35.532 79.968 3.873 5.5 8.02 10.805 12.374 15.938l-9.374-48.156.124-.032-27.03-68.844-15.782-3.968zm117.188 84.844l-51.532 8.156 10.125 52.094c8.577 7.49 17.707 14.332 27.314 20.437 14.612 9.287 30.332 16.88 46.687 22.594l62.626-13.69-4.344-31.124-90.875-58.47zm302.437.5l-64.22 41.25-42 47.375 4.408 6.156c12.027-5.545 23.57-12.144 34.406-19.72 23.97-16.76 44.604-38.304 60.28-62.97 2.51-3.947 4.87-7.99 7.125-12.092zm-122.78 97.656l-79.94 9.625-25.968 5.655c26.993 4 54.717 3.044 81.313-2.813 9.412-2.072 18.684-4.79 27.75-8.062l-3.156-4.406z"></path>
                                </svg>
                            </div>
                            Virtual
                        </li> */}
          </ul>
        </div>
        {tabUp === "Leagues" ? (
          <Leagues />
        ) : (
          <>
            <div className="all-complete">
              <div className="dropdown">
                <button
                  type="button"
                  id="abc"
                  aria-expanded="false"
                  className={`dropdown-toggle mb-0                ${openDropdown ? "active" : ""
                    }`}
                  onClick={() => setOpenDropdown(!openDropdown)}
                >
                  <div>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      className="me-1"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 20h2V8h3L8 4 4 8h3zm13-4h-3V4h-2v12h-3l4 4z"></path>
                    </svg>
                    {/* by Competition */}
                    {dropDownOption}
                  </div>
                </button>
                {openDropdown && (
                  <div
                    x-placement="bottom-start"
                    aria-labelledby="abc"
                    className="dropdown-menu"
                    data-popper-reference-hidden="false"
                    data-popper-escaped="false"
                    data-popper-placement="bottom-start"
                  // style="position: absolute; inset: 0px auto auto 0px; transform: translate3d(0px, 40.5px, 0px);"
                  >
                    {allDropDownOption
                      .filter((_value) => _value !== dropDownOption)
                      .map((_option) => {
                        return (
                          <a
                            data-rr-ui-dropdown-item=""
                            className="dropdown-item"
                            role="button"
                            onClick={() => {
                              setDropDownOption(_option);
                              setOpenDropdown(false);
                            }}
                          >
                            {_option}
                          </a>
                        );
                      })}
                    {/* <a data-rr-ui-dropdown-item="" className="dropdown-item" role="button" >by Time</a>
                                <a data-rr-ui-dropdown-item="" className="dropdown-item" role="button" >by Matched</a> */}
                  </div>
                )}
              </div>
              {tabUp === "Upcoming" && (
                <div className="today-tomorrow ">
                  <span onClick={() => changeTab("today")}>
                    {tab === "today" && (
                      <FontAwesomeIcon icon={faCircleCheck} />
                    )}{" "}
                    Today
                  </span>
                  <span onClick={() => changeTab("tomorrow")}>
                    {tab === "tomorrow" && (
                      <FontAwesomeIcon icon={faCircleCheck} />
                    )}{" "}
                    tomorrow
                  </span>
                </div>
              )}
            </div>

            {isLoadingMain ? (
              <div className="loader_top">
                <Loader />
              </div>
            ) : (
              <>
                {/* for cricket */}
                {categoryActive === "all" || categoryActive === "cricket" ? (
                  isLoading || pageData?.cricket?.length > 0 ? (
                    <>
                      {pageData &&
                        dropDownOption === "by Time1" &&
                        !isLoading &&
                        pageData.cricket.length > 0 ? (
                        <>
                          <div className="custom-inplay">
                            <div
                              className="matchlist-heading"
                              style={{ backgroundColor: "black" }}
                            >
                              <h6
                                className="sports-heading mb-0"
                                style={{ color: "white", borderColor: "white" }}
                              >
                                Cricket
                              </h6>
                            </div>
                            {pageData?.cricket?.map((sport, i) => {
                              return (
                                <>
                                  <div className="sport-accord-body-wrp" onClick={() => openDetailPage(sport)}>
                                    <div
                                      className="inplay-box"
                                      data-is-today-type={tab === "today"}
                                      data-is-tomorrow-type={tab === "tomorrow"}
                                      data-is-inplay-type={tab === "play"}
                                    >
                                      <div className="inplay text-center">
                                        {/* Today 22:30 */}
                                        {tab === "play"
                                          ? "In-Play"
                                          : tab === "today"
                                            ? "Today " +
                                            moment(sport?.openDate).format(
                                              "HH:mm"
                                            )
                                            : moment(sport?.openDate).format(
                                              "MMM DD HH:mm"
                                            )}
                                      </div>
                                    </div>
                                    <div className="fave bg-star-sprit-black"></div>
                                    <div className="pe-4 py-2">
                                      <span className="match-name">
                                        {sport?.eventName}
                                      </span>
                                      <div className="icon-sports d-flex align-items-center">
                                        <div>
                                          {sport.inPlay && (
                                            <img src={YoutubeImage} alt="" />
                                          )}
                                          {sport.f && !parlyActive && (
                                            <img src={FImage} alt="" />
                                          )}
                                          {sport.m1 && !parlyActive && (
                                            <img src={BImage} alt="" />
                                          )}
                                          {!parlyActive && (
                                            <img src={SImage} alt="" />
                                          )}
                                          {sport?.ematch > 0 && (
                                            <div
                                              style={{
                                                width: "2.4285714285714284rem",
                                                height: "2.669vw",
                                              }}
                                            >
                                              <svg
                                                width="100%"
                                                height="100%"
                                                viewBox="0 0 34 10"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clip-path="url(#clip0_3432_39516)">
                                                  <path
                                                    d="M9.165 0C9.625 0 10 0.374167 10 0.835V9.165C10 9.625 9.62583 10 9.165 10H0.835C0.725346 10 0.616766 9.9784 0.515459 9.93644C0.414152 9.89448 0.322103 9.83297 0.244566 9.75543C0.167029 9.6779 0.105523 9.58585 0.0635606 9.48454C0.0215979 9.38323 0 9.27465 0 9.165L0 0.835C0 0.375 0.374167 0 0.835 0H9.165Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <g clip-path="url(#clip1_3432_39516)">
                                                    <path
                                                      d="M8.571 3.76974L9.00005 2.54541H3.04486C2.74453 2.54541 2.47852 2.72396 2.38413 2.99603L1.28577 6.09086H3.39668L3.57688 5.58923H7.4469L7.8073 4.56045H3.93728L4.22046 3.76974H8.571Z"
                                                      fill="white"
                                                    ></path>
                                                    <path
                                                      d="M3.26438 6.36353H1.16192L1.03425 6.69686C0.889542 7.06807 1.22151 7.45443 1.68967 7.45443H7.14583L7.57143 6.36353H3.25587H3.26438Z"
                                                      fill="white"
                                                    ></path>
                                                  </g>
                                                  <path
                                                    d="M29.16 7.5001V3.1986H30.0805V7.5001H29.16ZM27.886 3.7936V3.0271H31.3475V3.7936H27.886Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M26.598 7.5001L26.4965 6.6286C26.4801 6.47227 26.4475 6.3416 26.3985 6.2366C26.3495 6.1316 26.276 6.05227 26.178 5.9986C26.08 5.9426 25.9446 5.9146 25.772 5.9146L24.6905 5.9111V5.2041L25.828 5.2006C26.0823 5.2006 26.2643 5.14227 26.374 5.0256C26.486 4.9066 26.542 4.73743 26.542 4.5181V4.4341C26.542 4.2171 26.486 4.0526 26.374 3.9406C26.2643 3.82627 26.08 3.7691 25.821 3.7691H24.68V3.0271H25.9505C26.4755 3.0271 26.8581 3.13327 27.0985 3.3456C27.3411 3.55793 27.4625 3.8601 27.4625 4.2521V4.3501C27.4625 4.6441 27.3913 4.87743 27.249 5.0501C27.1066 5.22277 26.8803 5.32543 26.57 5.3581V5.4841L26.3145 5.3581C26.5805 5.37677 26.7858 5.43277 26.9305 5.5261C27.0775 5.61943 27.1848 5.74893 27.2525 5.9146C27.3201 6.07793 27.3715 6.28093 27.4065 6.5236L27.543 7.5001H26.598ZM24.0535 7.5001V3.0271H24.9495V5.4561L24.9565 5.7956V7.5001H24.0535Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M21.4314 7.60162C20.8131 7.60162 20.3453 7.44062 20.0279 7.11862C19.7129 6.79428 19.5554 6.33112 19.5554 5.72912V4.81912C19.5554 4.21478 19.7129 3.74928 20.0279 3.42262C20.3453 3.09595 20.8131 2.93262 21.4314 2.93262C22.0498 2.93262 22.5164 3.09595 22.8314 3.42262C23.1488 3.74928 23.3074 4.21478 23.3074 4.81912V5.72912C23.3074 6.33112 23.1499 6.79428 22.8349 7.11862C22.5199 7.44062 22.0521 7.60162 21.4314 7.60162ZM21.4314 6.83862C21.7464 6.83862 21.9821 6.74528 22.1384 6.55862C22.2948 6.37195 22.3729 6.10945 22.3729 5.77112V4.77712C22.3729 4.42712 22.2948 4.15878 22.1384 3.97212C21.9821 3.78312 21.7464 3.68862 21.4314 3.68862C21.1188 3.68862 20.8843 3.78312 20.7279 3.97212C20.5716 4.15878 20.4934 4.42712 20.4934 4.77712V5.77112C20.4934 6.10945 20.5716 6.37195 20.7279 6.55862C20.8843 6.74528 21.1188 6.83862 21.4314 6.83862Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M16.2441 6.1561V5.4071H17.3851C17.6371 5.4071 17.8191 5.34877 17.9311 5.2321C18.0454 5.1131 18.1026 4.9416 18.1026 4.7176V4.4621C18.1026 4.23343 18.0466 4.06193 17.9346 3.9476C17.8226 3.83093 17.6406 3.7726 17.3886 3.7726H16.2441V3.0271H17.4411C17.9848 3.0271 18.3826 3.1496 18.6346 3.3946C18.8889 3.6396 19.0161 3.98727 19.0161 4.4376V4.7456C19.0161 5.19593 18.8889 5.5436 18.6346 5.7886C18.3826 6.0336 17.9848 6.1561 17.4411 6.1561H16.2441ZM15.6316 7.5001V3.0271H16.5346V5.6206L16.5381 6.0371V7.5001H15.6316Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M13.2396 7.59104C13.032 7.59104 12.8371 7.57587 12.6551 7.54554C12.4755 7.5152 12.3121 7.47787 12.1651 7.43354C12.0205 7.38687 11.8956 7.3402 11.7906 7.29354L11.7101 6.42554C11.8921 6.5212 12.108 6.60754 12.3576 6.68454C12.6073 6.7592 12.8733 6.79654 13.1556 6.79654C13.4543 6.79654 13.6701 6.75337 13.8031 6.66704C13.9361 6.5807 14.0026 6.4477 14.0026 6.26804V6.22954C14.0026 6.11287 13.9735 6.0172 13.9151 5.94254C13.8591 5.86554 13.7646 5.79787 13.6316 5.73954C13.4986 5.6812 13.3178 5.6217 13.0891 5.56104C12.7671 5.47237 12.5023 5.37204 12.2946 5.26004C12.0893 5.1457 11.9376 5.00454 11.8396 4.83654C11.7416 4.6662 11.6926 4.4527 11.6926 4.19604V4.15404C11.6926 3.76204 11.8245 3.46104 12.0881 3.25103C12.3541 3.04104 12.7461 2.93604 13.2641 2.93604C13.5861 2.93604 13.8626 2.9652 14.0936 3.02354C14.3246 3.08187 14.5183 3.14954 14.6746 3.22654L14.7551 4.03504C14.5801 3.9417 14.3795 3.8647 14.1531 3.80404C13.9291 3.74104 13.6841 3.70954 13.4181 3.70954C13.2198 3.70954 13.0623 3.7282 12.9456 3.76554C12.8313 3.80287 12.7485 3.8577 12.6971 3.93003C12.6481 4.00237 12.6236 4.08987 12.6236 4.19254V4.20304C12.6236 4.30804 12.6493 4.39904 12.7006 4.47604C12.7543 4.55304 12.8488 4.6242 12.9841 4.68954C13.1195 4.75254 13.312 4.81787 13.5616 4.88554C13.879 4.9742 14.138 5.06987 14.3386 5.17254C14.5416 5.2752 14.6921 5.4082 14.7901 5.57154C14.8881 5.73487 14.9371 5.9507 14.9371 6.21904V6.28204C14.9371 6.7137 14.796 7.04037 14.5136 7.26204C14.2336 7.48137 13.809 7.59104 13.2396 7.59104Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M1 1H10H33V9H10H1V1ZM0 0H1H33H34V1V9V10H33H1H0V9V1V0Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_3432_39516">
                                                    <rect
                                                      width="34"
                                                      height="10"
                                                      rx="1"
                                                      fill="white"
                                                    ></rect>
                                                  </clipPath>
                                                  <clipPath id="clip1_3432_39516">
                                                    <rect
                                                      width="8"
                                                      height="6"
                                                      fill="white"
                                                      transform="translate(1 2)"
                                                    ></rect>
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </div>
                                          )}
                                          {/* <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAMAAABG8BK2AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAOFQTFRFAAAA+7Ct+ZOP+pmV/dLQ919a9UQ9+ZKO9UA59lZQ+puX+Y6K+qSg92hi9lxX+IB79lNN+7Wy9UI7/MLA+YqG+HFs92Vg/M7N9UY/+qaj+H159kxF+piU+YiE/dTS/MXD+pyZ+Y+L+piV925p9k9J+7i1+62q9UdB9llT+qej/vX0//79+7y59ktF/MrI/////uzr+IJ9/MK/9lJM+YSA//7+/MTC/vPz/dLQ911X/vX192Jc//j3+peT/ubl9ldR/uPh92xn//n5+qek/dDO+Hp1929q+HJt+YaC/MfF+qmmvgLCEgAAAEt0Uk5TAP///y3////////////////s/5P///9A////////IID//////9n//////////////////////////////////////////////3P/qWg1ZgAAAY5JREFUeJzt2NlSwjAUBuDggqmySAXZkb0q6sEFdwVxhfd/IBNqO22xTU4bLxj7XzVnON+k6RBICVmJJNbWvaWNzeQWVqGUap6axmrbOGaHtdCUq5TipTR+NjTjKmV4KYtjyC5vyjkKOV7Q95BMnncVHIUCL+wjFVIssa5S0T2mZSxD0rytYg8ry4sllTLvq9rDKh/W8Iy5yFZjzY0iknfexuJp18VNjQNvmryTthbXrcV1c+kzDTfSTtJwSbYdSickwtOxlVYEhd22xXQjMd0fpRdJobRnMv2ITD9mYsYV41AFc3Q8ODmNzpwBwPBcCQODi0sVDJvQla6CgdF14IRkGYCbesCE5BkY3d6pYADufbd9FMMm9KCCAXh8+nWFsAw8j1UwkxcFNzV99VljDOO7wCjG/3EjmNGb5ovIM4Lvphwj3CmkmOF7MCLFTPviXVTMTD6EiJj5/DIklFX7uYuZmPlzZhaRmZmMeXQLHfscmwj+/xIcPWExZB72cMeOd3PiSFZqZ1mKgX1n8Q/zDVsYp5xwGQE5AAAAAElFTkSuQmCC" alt=""/>
                                                                                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABDCAMAAAASyFM4AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAgdQTFRFAAAAi5a0UYujQo+iQY+iQI+iUIqjjp65XI2nZY2ozNLebI2pQY6idpSvravFRo+kSouiwNXehJOyQ4+jQo6ivNbeepCuQ4+iu9feSZSmn8fQ6PHz/P3+/v//////8ff4msTOUZmqu9fe9/v73ezvb6u5ocjR8/j5+/z9utbdXqGxzOHm+/397/b4lMDKTpepf7TB5/Hz/v7+2entbam4rc/Y9vr7+vz9t9XcXaCwWZ6u0uXp7/X3kb7JTZeohrnE6vP10+Xpaae2utfer9DY9/r76fL0h7nFhrjEhLfDa6i3SpWn1Obq/P39w9ziVpytjr3I7fX39Pn6l8PNuNXd+fv84e3wZaS0QpCjZaW02unt/f7+v9ngVZuszeHnutfeudbdrs/Xbqq4RpOlvtng+fz83uzvbKm43uvvnMXP8vj5j73ITJaowtvi1+fsZ6a1dK674+7xtNPaWp6ve5Cun8bQ9Pj67vX2jLzHy+Dm5fDzwNrgocjSerC+/Pz9sNHYp8vU9vr67vX3hbjESJSmSZSn0OPoerG+Wp+v1ufrzuLniLrG+Pv8ocfR6PH0cay6RJKk2ejtxt7kU5qrkb/K8Pb49/v8n8fR5vHzcKy6Z6a0wdrgUpmrlMDL8vf4mMLNS5Wne5Guh7jEgLTBUpqru9bdwNTda42pdZSvy9Heipa0UYqjT4qjfnqb6gAAAK10Uk5TAP///////////0f///////+T////rf//s////////////////////////////////////////////////////////7n/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////s5P//03///8/w4FwAAACDElEQVR4nGNgoBpgZGJmIRqwIgALGzvcDA5mVrIBJxfEDG4KzGDl4QWbwcdPgRmsrAKCIEOEhCkyREQUZIiYOEWGsEqMGjJqyDAwRFJKWkYWN5CDA3kFRVyGSCopyxEHVFRxukRNnUgzNDS1cBkiqa1DpCG6evq4DDEwNCLSEGMTnAFrakakGeYWlrgMsbIm1jc2tna4DLF3INY3jk4QHc6Yhri4Iit0U3D3wAE8vbxxGWLl44tkhqyfPytBgGlIQCBSipQLCrYjx5CQUGTfhIVHkGFIZJQMkhnRMbGEzcA0xNYG2TfmcfEJ2EBiUjI+Q1JSiYncNC98LknPiCbCDBklS3yGZGYR4xCb7Bx8huSaE2NIXj6+gC0oJMY35kXFmIaUwA0pLSPGIeUVOfgMqUTJwFXVWOM3ocaKFY8htSjFUV29IitRANWQhkZkhzQ1t5BhSGscim/aiMjAWFyCu71KvCEmnshlTrskOYZ0dPoi125dxGRgDEO6UYqjnl4iiiNMQ4pQMnBf/wQyDOmYiJzkZSdNJtYMZEOmTEX2zbTpOYT0YjNECSUDz5hJtG+QDJmFUhzJzp5DtBlIhsydh+wQs/kLSDRkIciQcM9FIABNaYuXEFFVYBpCARg1ZGQYQmmXdik1OtfLwF305RR181dAxgoYOIgu2TEB50qoIQyrVpNnDM8axNDHoAAA+SwSTrYH+R0AAAAASUVORK5CYII=" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABECAMAAADtEXj5AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASNQTFRFAAAAdI/NR2u9P2W6vMnnRGm809zvTXC/fZfQXX3FVnfC0dru////+Pr97vH50NnujqTWSW2+eZPP7vL5/v7/7fH5ma3aqLrg/P3+/f3+uMbm2eHxf5jR8fT6zdftscDj/f7+3+b02uHy3eTzh5/U9Pf7xNDqX37Fg5vShZ3TlKnZ09vv+vv9obTd1d3w6Oz3aYfJnrHc9ff75On1cY3MztjtvMnndpHO6e33dJDN+fr9n7Ld9Pb7v8zoucfm2ODxtMPk09zvrb3io7Xerr7it8bl8vX6tcTk3+Xz0Nruj6XX9vj8mKzaXHzEvcrnzNbt7PD4gZrSkKbX9/j85+z2i6LV6+/4mq7bx9Lr3OPz1t7wusjm9/n86u73vsvob4zLVHbCak8QlQAAAGF0Uk5TAP///63/Gv///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9w28iMAAAHGSURBVHic7dhpU4JAHAZwdTUvtLbIJLVSS6wozyyt7LJLM7NTu7//p0hsmPYyWOSFNT5vgR/7l0dmFptthGJ3AFNx2DXB6TInqHE5+8SE2zwBgHtCNTzDEAB4VMM7nOFVDd9whm9sjI0/Z/gFowkEJ6cgy5ieMWz0Is6GGMZcmMcQBGmeNiJ8RG+iEGlEY7yGsEAai0vcRpwwYIKbEJKEsbzCb6QIQ06v6mVtXcIIZcNET+EmZmSyLCMXyyMpFElkCyXEEt0PQLbdTxLbQfTwTpFl4Od8j4ukHBeRw5VdwDLwtu/tV7EcKNgdDgHTODL0RPsJHAOmwdF25QSwjRpH28OnTIOv7YEQy0if8RhCAjKMc1H/QiSxKG3AC/w2VTKXCnaCVh/UqDewca8AFfwNwzJK2CiFJm3gFVRylNEsYCu9pgnYQv+Q+Zs2ZdzeoUSjThsDghgpbBn3D3ovpLRMGdmMgceJ5rFIGU8VPkKq0bN0+AixBWkjzmd0tV8DNZJcq3j+IRCjJulfqqXyAgHLkLtGBSlSHtQPufNqAAi/vX8M7lgvRb1etT9/76npjI1/blixN7Vij2zFXt2KbwY2K75djES+AEaqk7IsoVVbAAAAAElFTkSuQmCC" alt=""/>
                                                                                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABECAMAAADgDwi+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAATJQTFRFAAAA9NbI34Ra12Yz1mIt2Ww65Zt667KY1mMv2W499tvP8ci23HhL3oJY6auP2W8+4Yxm2Gs534Ze23NE6auO9drO+/Hs/vn4//////7+/fn3+u7o8s2845Rw34Rb8s279+DW4Y5n6q6T/PXx/PXy56KD2Go48Maz/v38+u3n4Ytj8MWy//39//797r2n6ayQ9NbI3HlM+eff8s+/6ayR/vr4/vz77Lad89HB+uzl5Jl39+HX/fj15p5+6rCV/vv59+DV7LWb78Kt/fbz7byl7big9NbJ4o9p8Me067Sb++7p7bqj/ff08cu5/PTw5JZz8May+OXc78Ou7Lae7bmi+OPZ9tvO99/U/fj26KaI34NZ+uvl89DA9NXH89LD4Ili+/Ht+ejg7Lef7r6o7buk45Vx+UqzxAAAAGZ0Uk5TAGD//////////zPT////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////KNevKQAAAaBJREFUeJzt2GdTwkAQBmDUiB1LFBPAKEQjBlBErFhBRbHG3rv//y8IhpHc5PayCfmATN7PzDO3t3tz5Hy+BktLaxvnKO3+GtLR6cyopKu7ivQ4XIie3qrSVw/CcQFd6a9PGdCVwfqUIU/xlGZT+OGR4KgARwyFI2MWijQeYgh/0kSUpcRkhFHJ5BSoKNNxJCIIMyqkJJJoREjNAsoca1NNSdOV+YwdRFigK9lFO8jSMl1ZMf5IjPCmSaLEpEirRkVewyBmhSwopzhTiIL0PtpXyILWN5wpm1uIxsTl7R2epeSxLS7sKrCyhz5C4j4PKsUgVhFSB6DCHeJHt6SCCndUwCrHfljhpBOkc3rGUMpRs+fU5AhFU9gKlLQRES/g3WVFLRkVw0m1pRTzxvIua2Pn/q12dW0nN1GqomjYQfnNLf0ckXtnlbt7ekUPjzaQZALalycRjYjPCqQUw+iVvJBXA9HpVw23mrcAo9PlNsXeLe/oeObDdEeZpo73f9JPop6vb9rd8i/+13lKcyrufAm781XuzguBO68VLr2cNEp+AHrwze8V/Og6AAAAAElFTkSuQmCC" alt=""/> */}
                                        </div>
                                        {/* <span class="inplay ms-1 in-play">In-play</span> */}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <div class="counter">0 - 0</div>
                                      <button
                                        type="button"
                                        className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                        onClick={(e) => {
                                          clickOnScoreBoard(
                                            e,
                                            `cricket_${sport?.gameId}`
                                          );
                                        }}
                                      >
                                        <svg
                                          stroke="currentColor"
                                          fill="#fe9f00"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 256 256"
                                          strokeWidth="0"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        class="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                      >
                                        <svg
                                          stroke="currentColor"
                                          fill="#fe9f00"
                                          stroke-width="0"
                                          viewBox="0 0 256 512"
                                          height="1em"
                                          width="1em"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>

                                  {activeAccordionsChart.includes(
                                    `cricket_${sport?.gameId}`
                                  ) &&
                                    activeAccordionsChartIds[sport?.gameId] && (
                                      <iframe
                                        title="chart-cricte"
                                        src={`https://www.satsports.net/score_widget/index.html?id=${activeAccordionsChartIds[
                                          sport?.gameId
                                        ]
                                          }&amp;aC=bGFzZXJib29rMjQ3`}
                                        // src={`https://www.satsports.net/score_widget/index.html?id=53176937&amp;aC=bGFzZXJib29rMjQ3`}
                                        width="100%"
                                      ></iframe>
                                    )}
                                </>

                                // <div className="sport-accord-body-wrp">
                                //     <div className='inplay-box' data-is-tomorrow-type="true">
                                //         <div className='inplay'>In Play</div>
                                //     </div>
                                //     <div className="fave bg-star-sprit-black"></div>
                                //     <div className="pe-4 py-2">
                                //         <span className="match-name">Central Sparks v South East Stars</span>
                                //         <div className='icon-sports d-flex align-items-center'>
                                //             <div>
                                //                 <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAMAAABG8BK2AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAOFQTFRFAAAA+7Ct+ZOP+pmV/dLQ919a9UQ9+ZKO9UA59lZQ+puX+Y6K+qSg92hi9lxX+IB79lNN+7Wy9UI7/MLA+YqG+HFs92Vg/M7N9UY/+qaj+H159kxF+piU+YiE/dTS/MXD+pyZ+Y+L+piV925p9k9J+7i1+62q9UdB9llT+qej/vX0//79+7y59ktF/MrI/////uzr+IJ9/MK/9lJM+YSA//7+/MTC/vPz/dLQ911X/vX192Jc//j3+peT/ubl9ldR/uPh92xn//n5+qek/dDO+Hp1929q+HJt+YaC/MfF+qmmvgLCEgAAAEt0Uk5TAP///y3////////////////s/5P///9A////////IID//////9n//////////////////////////////////////////////3P/qWg1ZgAAAY5JREFUeJzt2NlSwjAUBuDggqmySAXZkb0q6sEFdwVxhfd/IBNqO22xTU4bLxj7XzVnON+k6RBICVmJJNbWvaWNzeQWVqGUap6axmrbOGaHtdCUq5TipTR+NjTjKmV4KYtjyC5vyjkKOV7Q95BMnncVHIUCL+wjFVIssa5S0T2mZSxD0rytYg8ry4sllTLvq9rDKh/W8Iy5yFZjzY0iknfexuJp18VNjQNvmryTthbXrcV1c+kzDTfSTtJwSbYdSickwtOxlVYEhd22xXQjMd0fpRdJobRnMv2ITD9mYsYV41AFc3Q8ODmNzpwBwPBcCQODi0sVDJvQla6CgdF14IRkGYCbesCE5BkY3d6pYADufbd9FMMm9KCCAXh8+nWFsAw8j1UwkxcFNzV99VljDOO7wCjG/3EjmNGb5ovIM4Lvphwj3CmkmOF7MCLFTPviXVTMTD6EiJj5/DIklFX7uYuZmPlzZhaRmZmMeXQLHfscmwj+/xIcPWExZB72cMeOd3PiSFZqZ1mKgX1n8Q/zDVsYp5xwGQE5AAAAAElFTkSuQmCC" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABDCAMAAAASyFM4AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAgdQTFRFAAAAi5a0UYujQo+iQY+iQI+iUIqjjp65XI2nZY2ozNLebI2pQY6idpSvravFRo+kSouiwNXehJOyQ4+jQo6ivNbeepCuQ4+iu9feSZSmn8fQ6PHz/P3+/v//////8ff4msTOUZmqu9fe9/v73ezvb6u5ocjR8/j5+/z9utbdXqGxzOHm+/397/b4lMDKTpepf7TB5/Hz/v7+2entbam4rc/Y9vr7+vz9t9XcXaCwWZ6u0uXp7/X3kb7JTZeohrnE6vP10+Xpaae2utfer9DY9/r76fL0h7nFhrjEhLfDa6i3SpWn1Obq/P39w9ziVpytjr3I7fX39Pn6l8PNuNXd+fv84e3wZaS0QpCjZaW02unt/f7+v9ngVZuszeHnutfeudbdrs/Xbqq4RpOlvtng+fz83uzvbKm43uvvnMXP8vj5j73ITJaowtvi1+fsZ6a1dK674+7xtNPaWp6ve5Cun8bQ9Pj67vX2jLzHy+Dm5fDzwNrgocjSerC+/Pz9sNHYp8vU9vr67vX3hbjESJSmSZSn0OPoerG+Wp+v1ufrzuLniLrG+Pv8ocfR6PH0cay6RJKk2ejtxt7kU5qrkb/K8Pb49/v8n8fR5vHzcKy6Z6a0wdrgUpmrlMDL8vf4mMLNS5Wne5Guh7jEgLTBUpqru9bdwNTda42pdZSvy9Heipa0UYqjT4qjfnqb6gAAAK10Uk5TAP///////////0f///////+T////rf//s////////////////////////////////////////////////////////7n/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////s5P//03///8/w4FwAAACDElEQVR4nGNgoBpgZGJmIRqwIgALGzvcDA5mVrIBJxfEDG4KzGDl4QWbwcdPgRmsrAKCIEOEhCkyREQUZIiYOEWGsEqMGjJqyDAwRFJKWkYWN5CDA3kFRVyGSCopyxEHVFRxukRNnUgzNDS1cBkiqa1DpCG6evq4DDEwNCLSEGMTnAFrakakGeYWlrgMsbIm1jc2tna4DLF3INY3jk4QHc6Yhri4Iit0U3D3wAE8vbxxGWLl44tkhqyfPytBgGlIQCBSipQLCrYjx5CQUGTfhIVHkGFIZJQMkhnRMbGEzcA0xNYG2TfmcfEJ2EBiUjI+Q1JSiYncNC98LknPiCbCDBklS3yGZGYR4xCb7Bx8huSaE2NIXj6+gC0oJMY35kXFmIaUwA0pLSPGIeUVOfgMqUTJwFXVWOM3ocaKFY8htSjFUV29IitRANWQhkZkhzQ1t5BhSGscim/aiMjAWFyCu71KvCEmnshlTrskOYZ0dPoi125dxGRgDEO6UYqjnl4iiiNMQ4pQMnBf/wQyDOmYiJzkZSdNJtYMZEOmTEX2zbTpOYT0YjNECSUDz5hJtG+QDJmFUhzJzp5DtBlIhsydh+wQs/kLSDRkIciQcM9FIABNaYuXEFFVYBpCARg1ZGQYQmmXdik1OtfLwF305RR181dAxgoYOIgu2TEB50qoIQyrVpNnDM8axNDHoAAA+SwSTrYH+R0AAAAASUVORK5CYII=" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABECAMAAADtEXj5AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASNQTFRFAAAAdI/NR2u9P2W6vMnnRGm809zvTXC/fZfQXX3FVnfC0dru////+Pr97vH50NnujqTWSW2+eZPP7vL5/v7/7fH5ma3aqLrg/P3+/f3+uMbm2eHxf5jR8fT6zdftscDj/f7+3+b02uHy3eTzh5/U9Pf7xNDqX37Fg5vShZ3TlKnZ09vv+vv9obTd1d3w6Oz3aYfJnrHc9ff75On1cY3MztjtvMnndpHO6e33dJDN+fr9n7Ld9Pb7v8zoucfm2ODxtMPk09zvrb3io7Xerr7it8bl8vX6tcTk3+Xz0Nruj6XX9vj8mKzaXHzEvcrnzNbt7PD4gZrSkKbX9/j85+z2i6LV6+/4mq7bx9Lr3OPz1t7wusjm9/n86u73vsvob4zLVHbCak8QlQAAAGF0Uk5TAP///63/Gv///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9w28iMAAAHGSURBVHic7dhpU4JAHAZwdTUvtLbIJLVSS6wozyyt7LJLM7NTu7//p0hsmPYyWOSFNT5vgR/7l0dmFptthGJ3AFNx2DXB6TInqHE5+8SE2zwBgHtCNTzDEAB4VMM7nOFVDd9whm9sjI0/Z/gFowkEJ6cgy5ieMWz0Is6GGMZcmMcQBGmeNiJ8RG+iEGlEY7yGsEAai0vcRpwwYIKbEJKEsbzCb6QIQ06v6mVtXcIIZcNET+EmZmSyLCMXyyMpFElkCyXEEt0PQLbdTxLbQfTwTpFl4Od8j4ukHBeRw5VdwDLwtu/tV7EcKNgdDgHTODL0RPsJHAOmwdF25QSwjRpH28OnTIOv7YEQy0if8RhCAjKMc1H/QiSxKG3AC/w2VTKXCnaCVh/UqDewca8AFfwNwzJK2CiFJm3gFVRylNEsYCu9pgnYQv+Q+Zs2ZdzeoUSjThsDghgpbBn3D3ovpLRMGdmMgceJ5rFIGU8VPkKq0bN0+AixBWkjzmd0tV8DNZJcq3j+IRCjJulfqqXyAgHLkLtGBSlSHtQPufNqAAi/vX8M7lgvRb1etT9/76npjI1/blixN7Vij2zFXt2KbwY2K75djES+AEaqk7IsoVVbAAAAAElFTkSuQmCC" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABECAMAAADgDwi+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAATJQTFRFAAAA9NbI34Ra12Yz1mIt2Ww65Zt667KY1mMv2W499tvP8ci23HhL3oJY6auP2W8+4Yxm2Gs534Ze23NE6auO9drO+/Hs/vn4//////7+/fn3+u7o8s2845Rw34Rb8s279+DW4Y5n6q6T/PXx/PXy56KD2Go48Maz/v38+u3n4Ytj8MWy//39//797r2n6ayQ9NbI3HlM+eff8s+/6ayR/vr4/vz77Lad89HB+uzl5Jl39+HX/fj15p5+6rCV/vv59+DV7LWb78Kt/fbz7byl7big9NbJ4o9p8Me067Sb++7p7bqj/ff08cu5/PTw5JZz8May+OXc78Ou7Lae7bmi+OPZ9tvO99/U/fj26KaI34NZ+uvl89DA9NXH89LD4Ili+/Ht+ejg7Lef7r6o7buk45Vx+UqzxAAAAGZ0Uk5TAGD//////////zPT////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////KNevKQAAAaBJREFUeJzt2GdTwkAQBmDUiB1LFBPAKEQjBlBErFhBRbHG3rv//y8IhpHc5PayCfmATN7PzDO3t3tz5Hy+BktLaxvnKO3+GtLR6cyopKu7ivQ4XIie3qrSVw/CcQFd6a9PGdCVwfqUIU/xlGZT+OGR4KgARwyFI2MWijQeYgh/0kSUpcRkhFHJ5BSoKNNxJCIIMyqkJJJoREjNAsoca1NNSdOV+YwdRFigK9lFO8jSMl1ZMf5IjPCmSaLEpEirRkVewyBmhSwopzhTiIL0PtpXyILWN5wpm1uIxsTl7R2epeSxLS7sKrCyhz5C4j4PKsUgVhFSB6DCHeJHt6SCCndUwCrHfljhpBOkc3rGUMpRs+fU5AhFU9gKlLQRES/g3WVFLRkVw0m1pRTzxvIua2Pn/q12dW0nN1GqomjYQfnNLf0ckXtnlbt7ekUPjzaQZALalycRjYjPCqQUw+iVvJBXA9HpVw23mrcAo9PlNsXeLe/oeObDdEeZpo73f9JPop6vb9rd8i/+13lKcyrufAm781XuzguBO68VLr2cNEp+AHrwze8V/Og6AAAAAElFTkSuQmCC" alt=""/></div>
                                //             <span class="inplay ms-1 in-play">In-play</span>
                                //         </div>
                                //     </div>
                                //     <div className="d-flex align-items-center">
                                //         <div class="counter">0 - 0</div>
                                //         <button type="button" class="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg></button>
                                //     </div>
                                // </div>
                                // <div className="sport-accord-body-wrp">
                                //     <div className='inplay-box' data-is-inplay-type="true">
                                //         <div className='inplay'>In Play</div>
                                //     </div>
                                //     <div className="fave bg-star-sprit-black"></div>
                                //     <div className="pe-4 py-2">
                                //         <span className="match-name">Central Sparks v South East Stars</span>
                                //         <div className='icon-sports d-flex align-items-center'>
                                //             <div>
                                //                 <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAMAAABG8BK2AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAOFQTFRFAAAA+7Ct+ZOP+pmV/dLQ919a9UQ9+ZKO9UA59lZQ+puX+Y6K+qSg92hi9lxX+IB79lNN+7Wy9UI7/MLA+YqG+HFs92Vg/M7N9UY/+qaj+H159kxF+piU+YiE/dTS/MXD+pyZ+Y+L+piV925p9k9J+7i1+62q9UdB9llT+qej/vX0//79+7y59ktF/MrI/////uzr+IJ9/MK/9lJM+YSA//7+/MTC/vPz/dLQ911X/vX192Jc//j3+peT/ubl9ldR/uPh92xn//n5+qek/dDO+Hp1929q+HJt+YaC/MfF+qmmvgLCEgAAAEt0Uk5TAP///y3////////////////s/5P///9A////////IID//////9n//////////////////////////////////////////////3P/qWg1ZgAAAY5JREFUeJzt2NlSwjAUBuDggqmySAXZkb0q6sEFdwVxhfd/IBNqO22xTU4bLxj7XzVnON+k6RBICVmJJNbWvaWNzeQWVqGUap6axmrbOGaHtdCUq5TipTR+NjTjKmV4KYtjyC5vyjkKOV7Q95BMnncVHIUCL+wjFVIssa5S0T2mZSxD0rytYg8ry4sllTLvq9rDKh/W8Iy5yFZjzY0iknfexuJp18VNjQNvmryTthbXrcV1c+kzDTfSTtJwSbYdSickwtOxlVYEhd22xXQjMd0fpRdJobRnMv2ITD9mYsYV41AFc3Q8ODmNzpwBwPBcCQODi0sVDJvQla6CgdF14IRkGYCbesCE5BkY3d6pYADufbd9FMMm9KCCAXh8+nWFsAw8j1UwkxcFNzV99VljDOO7wCjG/3EjmNGb5ovIM4Lvphwj3CmkmOF7MCLFTPviXVTMTD6EiJj5/DIklFX7uYuZmPlzZhaRmZmMeXQLHfscmwj+/xIcPWExZB72cMeOd3PiSFZqZ1mKgX1n8Q/zDVsYp5xwGQE5AAAAAElFTkSuQmCC" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABDCAMAAAASyFM4AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAgdQTFRFAAAAi5a0UYujQo+iQY+iQI+iUIqjjp65XI2nZY2ozNLebI2pQY6idpSvravFRo+kSouiwNXehJOyQ4+jQo6ivNbeepCuQ4+iu9feSZSmn8fQ6PHz/P3+/v//////8ff4msTOUZmqu9fe9/v73ezvb6u5ocjR8/j5+/z9utbdXqGxzOHm+/397/b4lMDKTpepf7TB5/Hz/v7+2entbam4rc/Y9vr7+vz9t9XcXaCwWZ6u0uXp7/X3kb7JTZeohrnE6vP10+Xpaae2utfer9DY9/r76fL0h7nFhrjEhLfDa6i3SpWn1Obq/P39w9ziVpytjr3I7fX39Pn6l8PNuNXd+fv84e3wZaS0QpCjZaW02unt/f7+v9ngVZuszeHnutfeudbdrs/Xbqq4RpOlvtng+fz83uzvbKm43uvvnMXP8vj5j73ITJaowtvi1+fsZ6a1dK674+7xtNPaWp6ve5Cun8bQ9Pj67vX2jLzHy+Dm5fDzwNrgocjSerC+/Pz9sNHYp8vU9vr67vX3hbjESJSmSZSn0OPoerG+Wp+v1ufrzuLniLrG+Pv8ocfR6PH0cay6RJKk2ejtxt7kU5qrkb/K8Pb49/v8n8fR5vHzcKy6Z6a0wdrgUpmrlMDL8vf4mMLNS5Wne5Guh7jEgLTBUpqru9bdwNTda42pdZSvy9Heipa0UYqjT4qjfnqb6gAAAK10Uk5TAP///////////0f///////+T////rf//s////////////////////////////////////////////////////////7n/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////s5P//03///8/w4FwAAACDElEQVR4nGNgoBpgZGJmIRqwIgALGzvcDA5mVrIBJxfEDG4KzGDl4QWbwcdPgRmsrAKCIEOEhCkyREQUZIiYOEWGsEqMGjJqyDAwRFJKWkYWN5CDA3kFRVyGSCopyxEHVFRxukRNnUgzNDS1cBkiqa1DpCG6evq4DDEwNCLSEGMTnAFrakakGeYWlrgMsbIm1jc2tna4DLF3INY3jk4QHc6Yhri4Iit0U3D3wAE8vbxxGWLl44tkhqyfPytBgGlIQCBSipQLCrYjx5CQUGTfhIVHkGFIZJQMkhnRMbGEzcA0xNYG2TfmcfEJ2EBiUjI+Q1JSiYncNC98LknPiCbCDBklS3yGZGYR4xCb7Bx8huSaE2NIXj6+gC0oJMY35kXFmIaUwA0pLSPGIeUVOfgMqUTJwFXVWOM3ocaKFY8htSjFUV29IitRANWQhkZkhzQ1t5BhSGscim/aiMjAWFyCu71KvCEmnshlTrskOYZ0dPoi125dxGRgDEO6UYqjnl4iiiNMQ4pQMnBf/wQyDOmYiJzkZSdNJtYMZEOmTEX2zbTpOYT0YjNECSUDz5hJtG+QDJmFUhzJzp5DtBlIhsydh+wQs/kLSDRkIciQcM9FIABNaYuXEFFVYBpCARg1ZGQYQmmXdik1OtfLwF305RR181dAxgoYOIgu2TEB50qoIQyrVpNnDM8axNDHoAAA+SwSTrYH+R0AAAAASUVORK5CYII=" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABECAMAAADtEXj5AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAASNQTFRFAAAAdI/NR2u9P2W6vMnnRGm809zvTXC/fZfQXX3FVnfC0dru////+Pr97vH50NnujqTWSW2+eZPP7vL5/v7/7fH5ma3aqLrg/P3+/f3+uMbm2eHxf5jR8fT6zdftscDj/f7+3+b02uHy3eTzh5/U9Pf7xNDqX37Fg5vShZ3TlKnZ09vv+vv9obTd1d3w6Oz3aYfJnrHc9ff75On1cY3MztjtvMnndpHO6e33dJDN+fr9n7Ld9Pb7v8zoucfm2ODxtMPk09zvrb3io7Xerr7it8bl8vX6tcTk3+Xz0Nruj6XX9vj8mKzaXHzEvcrnzNbt7PD4gZrSkKbX9/j85+z2i6LV6+/4mq7bx9Lr3OPz1t7wusjm9/n86u73vsvob4zLVHbCak8QlQAAAGF0Uk5TAP///63/Gv///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9w28iMAAAHGSURBVHic7dhpU4JAHAZwdTUvtLbIJLVSS6wozyyt7LJLM7NTu7//p0hsmPYyWOSFNT5vgR/7l0dmFptthGJ3AFNx2DXB6TInqHE5+8SE2zwBgHtCNTzDEAB4VMM7nOFVDd9whm9sjI0/Z/gFowkEJ6cgy5ieMWz0Is6GGMZcmMcQBGmeNiJ8RG+iEGlEY7yGsEAai0vcRpwwYIKbEJKEsbzCb6QIQ06v6mVtXcIIZcNET+EmZmSyLCMXyyMpFElkCyXEEt0PQLbdTxLbQfTwTpFl4Od8j4ukHBeRw5VdwDLwtu/tV7EcKNgdDgHTODL0RPsJHAOmwdF25QSwjRpH28OnTIOv7YEQy0if8RhCAjKMc1H/QiSxKG3AC/w2VTKXCnaCVh/UqDewca8AFfwNwzJK2CiFJm3gFVRylNEsYCu9pgnYQv+Q+Zs2ZdzeoUSjThsDghgpbBn3D3ovpLRMGdmMgceJ5rFIGU8VPkKq0bN0+AixBWkjzmd0tV8DNZJcq3j+IRCjJulfqqXyAgHLkLtGBSlSHtQPufNqAAi/vX8M7lgvRb1etT9/76npjI1/blixN7Vij2zFXt2KbwY2K75djES+AEaqk7IsoVVbAAAAAElFTkSuQmCC" alt=""/><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABECAMAAADgDwi+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAATJQTFRFAAAA9NbI34Ra12Yz1mIt2Ww65Zt667KY1mMv2W499tvP8ci23HhL3oJY6auP2W8+4Yxm2Gs534Ze23NE6auO9drO+/Hs/vn4//////7+/fn3+u7o8s2845Rw34Rb8s279+DW4Y5n6q6T/PXx/PXy56KD2Go48Maz/v38+u3n4Ytj8MWy//39//797r2n6ayQ9NbI3HlM+eff8s+/6ayR/vr4/vz77Lad89HB+uzl5Jl39+HX/fj15p5+6rCV/vv59+DV7LWb78Kt/fbz7byl7big9NbJ4o9p8Me067Sb++7p7bqj/ff08cu5/PTw5JZz8May+OXc78Ou7Lae7bmi+OPZ9tvO99/U/fj26KaI34NZ+uvl89DA9NXH89LD4Ili+/Ht+ejg7Lef7r6o7buk45Vx+UqzxAAAAGZ0Uk5TAGD//////////zPT////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////KNevKQAAAaBJREFUeJzt2GdTwkAQBmDUiB1LFBPAKEQjBlBErFhBRbHG3rv//y8IhpHc5PayCfmATN7PzDO3t3tz5Hy+BktLaxvnKO3+GtLR6cyopKu7ivQ4XIie3qrSVw/CcQFd6a9PGdCVwfqUIU/xlGZT+OGR4KgARwyFI2MWijQeYgh/0kSUpcRkhFHJ5BSoKNNxJCIIMyqkJJJoREjNAsoca1NNSdOV+YwdRFigK9lFO8jSMl1ZMf5IjPCmSaLEpEirRkVewyBmhSwopzhTiIL0PtpXyILWN5wpm1uIxsTl7R2epeSxLS7sKrCyhz5C4j4PKsUgVhFSB6DCHeJHt6SCCndUwCrHfljhpBOkc3rGUMpRs+fU5AhFU9gKlLQRES/g3WVFLRkVw0m1pRTzxvIua2Pn/q12dW0nN1GqomjYQfnNLf0ckXtnlbt7ekUPjzaQZALalycRjYjPCqQUw+iVvJBXA9HpVw23mrcAo9PlNsXeLe/oeObDdEeZpo73f9JPop6vb9rd8i/+13lKcyrufAm781XuzguBO68VLr2cNEp+AHrwze8V/Og6AAAAAElFTkSuQmCC" alt=""/></div>
                                //             <span class="inplay ms-1 in-play">In-play</span>
                                //         </div>
                                //     </div>
                                //     <div className="d-flex align-items-center">
                                //         <div class="counter">0 - 0</div>
                                //         <button type="button" class="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg></button>
                                //     </div>
                                // </div>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        <div className="bg-skylight matchlist">
                          <div>
                            <div
                              className="matchlist-heading"

                            >
                              <h6
                                className="sports-heading mb-0"

                              >
                                {" "}
                                <img src={CricketBall} alt="" /> Cricket
                              </h6>
                              {dropDownOption === "by Competition" && (
                                <div
                                  className={`all-complete-all ${categoryState.cricket ? "active" : ""
                                    }`}
                                  onClick={() => handleClick("cricket")}
                                >
                                  <span className="mr-1">ALL</span>
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 24 24"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path d="M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path>
                                    <path d="M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path>
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>

                          {pageData &&
                            allTurnaments &&
                            !isLoading &&
                            pageData.cricket.length > 0 ? (
                            <>
                              {allTurnaments?.cricket
                                ?.sort(customSort)
                                .map((sport, i) => {
                                  return (
                                    <div className="bookmaker-wrp">
                                      <div className="bookmaker p-sm-2 sport-accordian">
                                        <div className="accordion">
                                          <div className="accordion-item">
                                            {console.log("sports", sport)}
                                            {dropDownOption ===
                                              "by Competition" && (
                                                <h2
                                                  className={`accordion-header ${activeAccordions.includes(
                                                    `cricket_${sport}`
                                                  ) ||
                                                    activeAccordions.includes(
                                                      "cricket_all"
                                                    ) ||
                                                    dropDownOption !==
                                                    "by Competition"
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                  onClick={() =>
                                                    toggleAccordion(
                                                      `cricket_${sport}`
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    aria-expanded="true"
                                                    className="accordion-button"
                                                  >
                                                    <span className="flex-grow-1">
                                                      {" "}
                                                      {sport ? sport : "other"}
                                                    </span>
                                                    <span className="sport-counter bg-yellow ">
                                                      {
                                                        pageData.cricket.filter(
                                                          (_) =>
                                                            _.Turnament === sport
                                                        ).length
                                                      }
                                                    </span>
                                                  </button>
                                                </h2>
                                              )}
                                            {pageData.cricket
                                              .filter(
                                                (_) => _.Turnament === sport
                                              )
                                              .map((item, i) => {
                                                return (
                                                  <div
                                                    onClick={() => {
                                                      openDetailPage(item);
                                                      // localStorage.setItem('sportsName', item.eventName);
                                                      // localStorage.setItem('sportsData', JSON.stringify(item))
                                                      // navigate(`/multimarket/${item.gameId}/${item.marketId}`);
                                                    }}
                                                    className={`accordion-collapse collapse ${activeAccordions.includes(
                                                      `cricket_${sport}`
                                                    ) ||
                                                      activeAccordions.includes(
                                                        "cricket_all"
                                                      ) ||
                                                      dropDownOption !==
                                                      "by Competition"
                                                      ? "slide-down show"
                                                      : "slide-up"
                                                      }`}
                                                  >
                                                    <div className="p-0 py-1 px-sm-3 px-2 accordion-body">
                                                      <div className="sport-accord-body">
                                                        <div className="">
                                                          <div className="sport-accord-body-wrp" onClick={() => openDetailPage(sport)}>
                                                            {!parlyActive && (
                                                              <div className="fave bg-star-sprit-black position-absolute start-0"></div>
                                                            )}
                                                            <div
                                                              className={`${!parlyActive
                                                                ? "ps-4"
                                                                : ""
                                                                }`}
                                                            >

                                                              <span
                                                                className="match-name"
                                                                onClick={() => {
                                                                  openDetailPage(
                                                                    item
                                                                  );
                                                                  // localStorage.setItem('sportsName', item.eventName);
                                                                  // localStorage.setItem('sportsData', JSON.stringify(item))
                                                                  // navigate(`/multimarket/${item.gameId}/${item.marketId}`);
                                                                }}
                                                              >
                                                                {item.eventName}
                                                              </span>
                                                              {dropDownOption !==
                                                                "by Competition" && (
                                                                  <div className="icon-sports d-flex align-items-center">
                                                                    <div className="in-play">
                                                                      In-play
                                                                    </div>
                                                                    {item.inPlay && <img src={Streaming} alt="streaming" />}
                                                                    {(item.f && !parlyActive) && <img src={fancybet} alt="fancybet" />}
                                                                    {(item.m1 && !parlyActive) && <img src={bookmaker} alt="bookmaker" />}
                                                                  </div>
                                                                )}
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                              <div className="counter">
                                                                0 - 0
                                                              </div>
                                                              <button
                                                                type="button"
                                                                className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                                                onClick={(
                                                                  e
                                                                ) => {
                                                                  clickOnScoreBoard(
                                                                    e,
                                                                    `cricket_${item?.gameId}`
                                                                  );
                                                                }}
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#fe9f00"
                                                                  width="1em"
                                                                  height="1em"
                                                                  viewBox="0 0 256 256"
                                                                  strokeWidth="0"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z" />
                                                                </svg>
                                                              </button>

                                                              <button
                                                                type="button"
                                                                className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#fe9f00"
                                                                  strokeWidth="0"
                                                                  viewBox="0 0 256 512"
                                                                  height="1em"
                                                                  width="1em"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                                                                </svg>
                                                              </button>
                                                            </div>
                                                          </div>

                                                          {console.log(
                                                            "item",
                                                            item
                                                          )}

                                                          {!parlyActive &&
                                                            dropDownOption ===
                                                            "by Competition" && (
                                                              <div className="sports-team-table">
                                                                <div className="match-odd-table p-3 px-0 py-1">
                                                                  <div className="d-flex back-lay-head justify-content-end ms-auto pb-1 w-100">
                                                                    <div className="half-table">
                                                                      <div className="h-icon">
                                                                        {item.inPlay && <img src={Streaming} alt="streaming" />}
                                                                        {(item.f && !parlyActive) && <img src={fancybet} alt="fancybet" />}
                                                                        {(item.m1 && !parlyActive) && <img src={bookmaker} alt="bookmaker" />}
                                                                        <div className="in-play">
                                                                          In-play
                                                                        </div>
                                                                      </div>
                                                                      {/* <strong className="px-2">27,111,747.02</strong> */}
                                                                    </div>
                                                                    <span
                                                                      className="text-center half-table-text"
                                                                      style={{
                                                                        width:
                                                                          "64px",
                                                                      }}
                                                                    >
                                                                      Back
                                                                    </span>
                                                                    <span
                                                                      className="text-center half-table-text"
                                                                      style={{
                                                                        width:
                                                                          "64px",
                                                                      }}
                                                                    >
                                                                      Lay
                                                                    </span>
                                                                  </div>
                                                                  <ul className="mb-0 rounded position-relative p-0">
                                                                    <li>
                                                                      <h2>
                                                                        {
                                                                          item?.eventName?.split(
                                                                            " v "
                                                                          )[0]
                                                                        }{" "}
                                                                      </h2>
                                                                      <div className="lay-back-table ">
                                                                        <div
                                                                          id="back_odds_0"
                                                                          className="back"
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.back1
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                        <div
                                                                          title="32-152.14"
                                                                          id="lay_odds_0"
                                                                          className="lay  "
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.lay1
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </li>
                                                                    <li>
                                                                      <h2>
                                                                        {
                                                                          item?.eventName?.split(
                                                                            " v "
                                                                          )[1]
                                                                        }{" "}
                                                                      </h2>
                                                                      <div className="lay-back-table ">
                                                                        <div
                                                                          title="1.03-87868.13"
                                                                          id="back_odds_0"
                                                                          className="back spark-back "
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.back2
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                        <div
                                                                          id="lay_odds_0"
                                                                          className="lay spark-lay "
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.lay2
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </li>
                                                                    {item?.RunnersNumber >
                                                                      2 && (
                                                                        <>
                                                                          <li>
                                                                            <h2>
                                                                              {" "}
                                                                              The
                                                                              Draw{" "}
                                                                            </h2>
                                                                            <div className="lay-back-table ">
                                                                              <div
                                                                                title="1.03-87868.13"
                                                                                id="back_odds_0"
                                                                                className="back spark-back "
                                                                              >
                                                                                <span className="">
                                                                                  <strong>
                                                                                    {
                                                                                      item.back3
                                                                                    }
                                                                                  </strong>
                                                                                  <span className="d-block">
                                                                                    {Math.floor(
                                                                                      Math.random() *
                                                                                      10
                                                                                    )}
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                              <div
                                                                                id="lay_odds_0"
                                                                                className="lay spark-lay "
                                                                              >
                                                                                <span className="">
                                                                                  <strong>
                                                                                    {
                                                                                      item.lay3
                                                                                    }
                                                                                  </strong>
                                                                                  <span className="d-block">
                                                                                    {Math.floor(
                                                                                      Math.random() *
                                                                                      10
                                                                                    )}
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          </li>
                                                                        </>
                                                                      )}
                                                                  </ul>
                                                                </div>
                                                              </div>
                                                            )}
                                                          {activeAccordionsChart.includes(
                                                            `cricket_${item?.gameId}`
                                                          ) &&
                                                            activeAccordionsChartIds[
                                                            item?.gameId
                                                            ] && (
                                                              <iframe
                                                                title="chart-cricte"
                                                                src={`https://www.satsports.net/score_widget/index.html?id=${activeAccordionsChartIds[
                                                                  item?.gameId
                                                                ]
                                                                  }&amp;aC=bGFzZXJib29rMjQ3`}
                                                                // src={`https://www.satsports.net/score_widget/index.html?id=53176937&amp;aC=bGFzZXJib29rMjQ3`}
                                                                width="100%"
                                                              ></iframe>
                                                            )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          ) : isLoading ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                style={{ width: 100 }}
                                src={LoaderImage}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="no-deta">
                              <div className="no-box">
                                <FontAwesomeIcon icon={faFile} />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    categoryActive !== "all" && (
                      <div className="no-deta">
                        <div className="no-box">
                          <FontAwesomeIcon icon={faFile} />
                        </div>
                      </div>
                    )
                  )
                ) : (
                  ""
                )}

                {/* for soccer */}
                {categoryActive === "all" || categoryActive === "soccer" ? (
                  isLoading || pageData?.soccer?.length > 0 ? (
                    <>
                      {pageData &&
                        dropDownOption === "by Time1" &&
                        !isLoading &&
                        pageData.cricket.length > 0 ? (
                        <>
                          <div className="custom-inplay">
                            <div
                              className="matchlist-heading"
                              style={{ backgroundColor: "black" }}
                            >
                              <h6
                                className="sports-heading mb-0"
                                style={{ color: "white", borderColor: "white" }}
                              >
                                Soccer
                              </h6>
                            </div>
                            {pageData?.cricket?.map((sport, i) => {
                              return (
                                <>
                                  <div className="sport-accord-body-wrp" onClick={() => openDetailPage(sport)}>
                                    <div
                                      className="inplay-box"
                                      data-is-today-type={tab === "today"}
                                      data-is-tomorrow-type={tab === "tomorrow"}
                                      data-is-inplay-type={tab === "play"}
                                    >
                                      <div className="inplay text-center">
                                        {/* Today 22:30 */}
                                        {tab === "play"
                                          ? "In-Play"
                                          : tab === "today"
                                            ? "Today " +
                                            moment(sport?.openDate).format(
                                              "HH:mm"
                                            )
                                            : moment(sport?.openDate).format(
                                              "MMM DD HH:mm"
                                            )}
                                      </div>
                                    </div>
                                    <div className="fave bg-star-sprit-black"></div>
                                    <div className="pe-4 py-2">
                                      <span className="match-name">
                                        {sport.eventName}
                                      </span>
                                      <div className="icon-sports d-flex align-items-center">
                                        <div>
                                          {sport.inPlay && (
                                            <img src={YoutubeImage} alt="" />
                                          )}
                                          {sport.f && !parlyActive && (
                                            <img src={FImage} alt="" />
                                          )}
                                          {sport.m1 && !parlyActive && (
                                            <img src={BImage} alt="" />
                                          )}
                                          {!parlyActive && (
                                            <img src={SImage} alt="" />
                                          )}
                                          {sport?.ematch > 0 && (
                                            <div
                                              style={{
                                                width: "2.4285714285714284rem",
                                                height: "2.669vw",
                                              }}
                                            >
                                              <svg
                                                width="100%"
                                                height="100%"
                                                viewBox="0 0 34 10"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clip-path="url(#clip0_3432_39516)">
                                                  <path
                                                    d="M9.165 0C9.625 0 10 0.374167 10 0.835V9.165C10 9.625 9.62583 10 9.165 10H0.835C0.725346 10 0.616766 9.9784 0.515459 9.93644C0.414152 9.89448 0.322103 9.83297 0.244566 9.75543C0.167029 9.6779 0.105523 9.58585 0.0635606 9.48454C0.0215979 9.38323 0 9.27465 0 9.165L0 0.835C0 0.375 0.374167 0 0.835 0H9.165Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <g clip-path="url(#clip1_3432_39516)">
                                                    <path
                                                      d="M8.571 3.76974L9.00005 2.54541H3.04486C2.74453 2.54541 2.47852 2.72396 2.38413 2.99603L1.28577 6.09086H3.39668L3.57688 5.58923H7.4469L7.8073 4.56045H3.93728L4.22046 3.76974H8.571Z"
                                                      fill="white"
                                                    ></path>
                                                    <path
                                                      d="M3.26438 6.36353H1.16192L1.03425 6.69686C0.889542 7.06807 1.22151 7.45443 1.68967 7.45443H7.14583L7.57143 6.36353H3.25587H3.26438Z"
                                                      fill="white"
                                                    ></path>
                                                  </g>
                                                  <path
                                                    d="M29.16 7.5001V3.1986H30.0805V7.5001H29.16ZM27.886 3.7936V3.0271H31.3475V3.7936H27.886Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M26.598 7.5001L26.4965 6.6286C26.4801 6.47227 26.4475 6.3416 26.3985 6.2366C26.3495 6.1316 26.276 6.05227 26.178 5.9986C26.08 5.9426 25.9446 5.9146 25.772 5.9146L24.6905 5.9111V5.2041L25.828 5.2006C26.0823 5.2006 26.2643 5.14227 26.374 5.0256C26.486 4.9066 26.542 4.73743 26.542 4.5181V4.4341C26.542 4.2171 26.486 4.0526 26.374 3.9406C26.2643 3.82627 26.08 3.7691 25.821 3.7691H24.68V3.0271H25.9505C26.4755 3.0271 26.8581 3.13327 27.0985 3.3456C27.3411 3.55793 27.4625 3.8601 27.4625 4.2521V4.3501C27.4625 4.6441 27.3913 4.87743 27.249 5.0501C27.1066 5.22277 26.8803 5.32543 26.57 5.3581V5.4841L26.3145 5.3581C26.5805 5.37677 26.7858 5.43277 26.9305 5.5261C27.0775 5.61943 27.1848 5.74893 27.2525 5.9146C27.3201 6.07793 27.3715 6.28093 27.4065 6.5236L27.543 7.5001H26.598ZM24.0535 7.5001V3.0271H24.9495V5.4561L24.9565 5.7956V7.5001H24.0535Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M21.4314 7.60162C20.8131 7.60162 20.3453 7.44062 20.0279 7.11862C19.7129 6.79428 19.5554 6.33112 19.5554 5.72912V4.81912C19.5554 4.21478 19.7129 3.74928 20.0279 3.42262C20.3453 3.09595 20.8131 2.93262 21.4314 2.93262C22.0498 2.93262 22.5164 3.09595 22.8314 3.42262C23.1488 3.74928 23.3074 4.21478 23.3074 4.81912V5.72912C23.3074 6.33112 23.1499 6.79428 22.8349 7.11862C22.5199 7.44062 22.0521 7.60162 21.4314 7.60162ZM21.4314 6.83862C21.7464 6.83862 21.9821 6.74528 22.1384 6.55862C22.2948 6.37195 22.3729 6.10945 22.3729 5.77112V4.77712C22.3729 4.42712 22.2948 4.15878 22.1384 3.97212C21.9821 3.78312 21.7464 3.68862 21.4314 3.68862C21.1188 3.68862 20.8843 3.78312 20.7279 3.97212C20.5716 4.15878 20.4934 4.42712 20.4934 4.77712V5.77112C20.4934 6.10945 20.5716 6.37195 20.7279 6.55862C20.8843 6.74528 21.1188 6.83862 21.4314 6.83862Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M16.2441 6.1561V5.4071H17.3851C17.6371 5.4071 17.8191 5.34877 17.9311 5.2321C18.0454 5.1131 18.1026 4.9416 18.1026 4.7176V4.4621C18.1026 4.23343 18.0466 4.06193 17.9346 3.9476C17.8226 3.83093 17.6406 3.7726 17.3886 3.7726H16.2441V3.0271H17.4411C17.9848 3.0271 18.3826 3.1496 18.6346 3.3946C18.8889 3.6396 19.0161 3.98727 19.0161 4.4376V4.7456C19.0161 5.19593 18.8889 5.5436 18.6346 5.7886C18.3826 6.0336 17.9848 6.1561 17.4411 6.1561H16.2441ZM15.6316 7.5001V3.0271H16.5346V5.6206L16.5381 6.0371V7.5001H15.6316Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M13.2396 7.59104C13.032 7.59104 12.8371 7.57587 12.6551 7.54554C12.4755 7.5152 12.3121 7.47787 12.1651 7.43354C12.0205 7.38687 11.8956 7.3402 11.7906 7.29354L11.7101 6.42554C11.8921 6.5212 12.108 6.60754 12.3576 6.68454C12.6073 6.7592 12.8733 6.79654 13.1556 6.79654C13.4543 6.79654 13.6701 6.75337 13.8031 6.66704C13.9361 6.5807 14.0026 6.4477 14.0026 6.26804V6.22954C14.0026 6.11287 13.9735 6.0172 13.9151 5.94254C13.8591 5.86554 13.7646 5.79787 13.6316 5.73954C13.4986 5.6812 13.3178 5.6217 13.0891 5.56104C12.7671 5.47237 12.5023 5.37204 12.2946 5.26004C12.0893 5.1457 11.9376 5.00454 11.8396 4.83654C11.7416 4.6662 11.6926 4.4527 11.6926 4.19604V4.15404C11.6926 3.76204 11.8245 3.46104 12.0881 3.25103C12.3541 3.04104 12.7461 2.93604 13.2641 2.93604C13.5861 2.93604 13.8626 2.9652 14.0936 3.02354C14.3246 3.08187 14.5183 3.14954 14.6746 3.22654L14.7551 4.03504C14.5801 3.9417 14.3795 3.8647 14.1531 3.80404C13.9291 3.74104 13.6841 3.70954 13.4181 3.70954C13.2198 3.70954 13.0623 3.7282 12.9456 3.76554C12.8313 3.80287 12.7485 3.8577 12.6971 3.93003C12.6481 4.00237 12.6236 4.08987 12.6236 4.19254V4.20304C12.6236 4.30804 12.6493 4.39904 12.7006 4.47604C12.7543 4.55304 12.8488 4.6242 12.9841 4.68954C13.1195 4.75254 13.312 4.81787 13.5616 4.88554C13.879 4.9742 14.138 5.06987 14.3386 5.17254C14.5416 5.2752 14.6921 5.4082 14.7901 5.57154C14.8881 5.73487 14.9371 5.9507 14.9371 6.21904V6.28204C14.9371 6.7137 14.796 7.04037 14.5136 7.26204C14.2336 7.48137 13.809 7.59104 13.2396 7.59104Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M1 1H10H33V9H10H1V1ZM0 0H1H33H34V1V9V10H33H1H0V9V1V0Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_3432_39516">
                                                    <rect
                                                      width="34"
                                                      height="10"
                                                      rx="1"
                                                      fill="white"
                                                    ></rect>
                                                  </clipPath>
                                                  <clipPath id="clip1_3432_39516">
                                                    <rect
                                                      width="8"
                                                      height="6"
                                                      fill="white"
                                                      transform="translate(1 2)"
                                                    ></rect>
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </div>
                                          )}
                                        </div>
                                        {/* <span class="inplay ms-1 in-play">In-play</span> */}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <div class="counter">0 - 0</div>
                                      <button
                                        type="button"
                                        className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                        onClick={(e) => {
                                          clickOnScoreBoard(
                                            e,
                                            `soccer_${sport?.gameId}`
                                          );
                                        }}
                                      >
                                        <svg
                                          stroke="currentColor"
                                          fill="#fe9f00"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 256 256"
                                          strokeWidth="0"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        class="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                      >
                                        <svg
                                          stroke="currentColor"
                                          fill="#fe9f00"
                                          stroke-width="0"
                                          viewBox="0 0 256 512"
                                          height="1em"
                                          width="1em"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>

                                  {activeAccordionsChart.includes(
                                    `soccer_${sport?.gameId}`
                                  ) &&
                                    activeAccordionsChartIds[sport?.gameId] && (
                                      <iframe
                                        title="chart-cricte"
                                        src={`https://www.satsports.net/score_widget/index.html?id=${activeAccordionsChartIds[
                                          sport?.gameId
                                        ]
                                          }&amp;aC=bGFzZXJib29rMjQ3`}
                                        // src={`https://www.satsports.net/score_widget/index.html?id=53176937&amp;aC=bGFzZXJib29rMjQ3`}
                                        width="100%"
                                      ></iframe>
                                    )}
                                </>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        <div className="bg-skylight matchlist">
                          <div>
                            <div
                              className="matchlist-heading"

                            >
                              <h6
                                className="sports-heading mb-0"

                              >
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  stroke-width="0"
                                  viewBox="0 0 512 512"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M255.03 33.813c-1.834-.007-3.664-.007-5.5.03-6.73.14-13.462.605-20.155 1.344.333.166.544.32.47.438L204.78 75.063l73.907 49.437-.125.188 70.625.28L371 79.282 342.844 52c-15.866-6.796-32.493-11.776-49.47-14.78-12.65-2.24-25.497-3.36-38.343-3.407zM190.907 88.25l-73.656 36.78-13.813 98.407 51.344 33.657 94.345-43.438 14.875-76.5-73.094-48.906zm196.344.344l-21.25 44.5 36.75 72.72 62.063 38.905 11.312-21.282c.225.143.45.403.656.75-.77-4.954-1.71-9.893-2.81-14.782-6.446-28.59-18.59-55.962-35.5-79.97-9.07-12.872-19.526-24.778-31.095-35.5l-20.125-5.342zm-302.656 23c-6.906 8.045-13.257 16.56-18.938 25.5-15.676 24.664-26.44 52.494-31.437 81.312C31.783 232.446 30.714 246.73 31 261l20.25 5.094 33.03-40.5L98.75 122.53l-14.156-10.936zm312.719 112.844l-55.813 44.75-3.47 101.093 39.626 21.126 77.188-49.594 4.406-78.75-.094.157-61.844-38.783zm-140.844 6.406l-94.033 43.312-1.218 76.625 89.155 57.376 68.938-36.437 3.437-101.75-66.28-39.126zm-224.22 49.75c.91 8.436 2.29 16.816 4.156 25.094 6.445 28.59 18.62 55.96 35.532 79.968 3.873 5.5 8.02 10.805 12.374 15.938l-9.374-48.156.124-.032-27.03-68.844-15.782-3.968zm117.188 84.844l-51.532 8.156 10.125 52.094c8.577 7.49 17.707 14.332 27.314 20.437 14.612 9.287 30.332 16.88 46.687 22.594l62.626-13.69-4.344-31.124-90.875-58.47zm302.437.5l-64.22 41.25-42 47.375 4.408 6.156c12.027-5.545 23.57-12.144 34.406-19.72 23.97-16.76 44.604-38.304 60.28-62.97 2.51-3.947 4.87-7.99 7.125-12.092zm-122.78 97.656l-79.94 9.625-25.968 5.655c26.993 4 54.717 3.044 81.313-2.813 9.412-2.072 18.684-4.79 27.75-8.062l-3.156-4.406z"></path>
                                </svg>
                                Soccer
                              </h6>
                              {dropDownOption === "by Competition" && (
                                <div
                                  className={`all-complete-all ${categoryState.soccer ? "active" : ""
                                    }`}
                                  onClick={() => handleClick("soccer")}
                                >
                                  <span className="mr-1">ALL</span>
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 24 24"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path d="M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path>
                                    <path d="M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path>
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>

                          {pageData &&
                            allTurnaments &&
                            !isLoading &&
                            pageData.soccer.length > 0 ? (
                            <>
                              {allTurnaments?.soccer
                                ?.sort(customSort)
                                .map((sport, i) => {
                                  return (
                                    <div className="bookmaker-wrp">
                                      <div className="bookmaker p-sm-2 sport-accordian">
                                        <div className="accordion">
                                          <div className="accordion-item">
                                            {dropDownOption ===
                                              "by Competition" && (
                                                <h2
                                                  className={`accordion-header ${activeAccordions.includes(
                                                    `soccer_${sport}`
                                                  ) ||
                                                    activeAccordions.includes(
                                                      "soccer_all"
                                                    ) ||
                                                    dropDownOption !==
                                                    "by Competition"
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                  onClick={() =>
                                                    toggleAccordion(
                                                      `soccer_${sport}`
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    aria-expanded="true"
                                                    className="accordion-button"
                                                  >
                                                    <span className="flex-grow-1">
                                                      {" "}
                                                      {sport ? sport : "other"}
                                                    </span>
                                                    <span className="sport-counter bg-yellow ">
                                                      {
                                                        pageData.soccer.filter(
                                                          (_) =>
                                                            _.Turnament === sport
                                                        ).length
                                                      }
                                                    </span>
                                                  </button>
                                                </h2>
                                              )}
                                            {pageData.soccer
                                              .filter(
                                                (_) => _.Turnament === sport
                                              )
                                              .map((item, i) => {
                                                return (
                                                  <div
                                                    onClick={() => {
                                                      localStorage.setItem(
                                                        "sportsName",
                                                        item.eventName
                                                      );
                                                      localStorage.setItem(
                                                        "sportsData",
                                                        JSON.stringify(item)
                                                      );
                                                      navigate(
                                                        `/multimarket/${item.gameId}/${item.marketId}`
                                                      );
                                                    }}
                                                    className={`accordion-collapse collapse ${activeAccordions.includes(
                                                      `soccer_${sport}`
                                                    ) ||
                                                      activeAccordions.includes(
                                                        "soccer_all"
                                                      ) ||
                                                      dropDownOption !==
                                                      "by Competition"
                                                      ? "slide-down show"
                                                      : "slide-up"
                                                      }`}
                                                  >
                                                    <div className="p-0 py-1 px-sm-3 px-2 accordion-body">
                                                      <div className="sport-accord-body">
                                                        <div className="">
                                                          <div className="sport-accord-body-wrp" onClick={() => openDetailPage(sport)}>
                                                            {!parlyActive && (
                                                              <div className="fave bg-star-sprit-black position-absolute start-0"></div>
                                                            )}
                                                            <div
                                                              className={`${!parlyActive
                                                                ? "ps-4"
                                                                : ""
                                                                }`}
                                                            >
                                                              {/* {dropDownOption ===
                                                                "by Competition" && (
                                                                <div className="icon-sports d-flex align-items-center">
                                                                  <div>
                                                                    {item.inPlay && (
                                                                      <img
                                                                        src={
                                                                          YoutubeImage
                                                                        }
                                                                        alt=""
                                                                      />
                                                                    )}
                                                                    {item.f &&
                                                                      !parlyActive && (
                                                                        <img
                                                                          src={
                                                                            FImage
                                                                          }
                                                                          alt=""
                                                                        />
                                                                      )}
                                                                    {item.m1 &&
                                                                      !parlyActive && (
                                                                        <img
                                                                          src={
                                                                            BImage
                                                                          }
                                                                          alt=""
                                                                        />
                                                                      )}
                                                                    {!parlyActive && (
                                                                      <img
                                                                        src={
                                                                          SImage
                                                                        }
                                                                        alt=""
                                                                      />
                                                                    )}
                                                                    {item?.ematch >
                                                                      0 && (
                                                                      <div
                                                                        style={{
                                                                          width:
                                                                            "2.4285714285714284rem",
                                                                          height:
                                                                            "2.669vw",
                                                                        }}
                                                                      >
                                                                        <svg
                                                                          width="100%"
                                                                          height="100%"
                                                                          viewBox="0 0 34 10"
                                                                          fill="none"
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                          <g clip-path="url(#clip0_3432_39516)">
                                                                            <path
                                                                              d="M9.165 0C9.625 0 10 0.374167 10 0.835V9.165C10 9.625 9.62583 10 9.165 10H0.835C0.725346 10 0.616766 9.9784 0.515459 9.93644C0.414152 9.89448 0.322103 9.83297 0.244566 9.75543C0.167029 9.6779 0.105523 9.58585 0.0635606 9.48454C0.0215979 9.38323 0 9.27465 0 9.165L0 0.835C0 0.375 0.374167 0 0.835 0H9.165Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                            <g clip-path="url(#clip1_3432_39516)">
                                                                              <path
                                                                                d="M8.571 3.76974L9.00005 2.54541H3.04486C2.74453 2.54541 2.47852 2.72396 2.38413 2.99603L1.28577 6.09086H3.39668L3.57688 5.58923H7.4469L7.8073 4.56045H3.93728L4.22046 3.76974H8.571Z"
                                                                                fill="white"
                                                                              ></path>
                                                                              <path
                                                                                d="M3.26438 6.36353H1.16192L1.03425 6.69686C0.889542 7.06807 1.22151 7.45443 1.68967 7.45443H7.14583L7.57143 6.36353H3.25587H3.26438Z"
                                                                                fill="white"
                                                                              ></path>
                                                                            </g>
                                                                            <path
                                                                              d="M29.16 7.5001V3.1986H30.0805V7.5001H29.16ZM27.886 3.7936V3.0271H31.3475V3.7936H27.886Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                            <path
                                                                              d="M26.598 7.5001L26.4965 6.6286C26.4801 6.47227 26.4475 6.3416 26.3985 6.2366C26.3495 6.1316 26.276 6.05227 26.178 5.9986C26.08 5.9426 25.9446 5.9146 25.772 5.9146L24.6905 5.9111V5.2041L25.828 5.2006C26.0823 5.2006 26.2643 5.14227 26.374 5.0256C26.486 4.9066 26.542 4.73743 26.542 4.5181V4.4341C26.542 4.2171 26.486 4.0526 26.374 3.9406C26.2643 3.82627 26.08 3.7691 25.821 3.7691H24.68V3.0271H25.9505C26.4755 3.0271 26.8581 3.13327 27.0985 3.3456C27.3411 3.55793 27.4625 3.8601 27.4625 4.2521V4.3501C27.4625 4.6441 27.3913 4.87743 27.249 5.0501C27.1066 5.22277 26.8803 5.32543 26.57 5.3581V5.4841L26.3145 5.3581C26.5805 5.37677 26.7858 5.43277 26.9305 5.5261C27.0775 5.61943 27.1848 5.74893 27.2525 5.9146C27.3201 6.07793 27.3715 6.28093 27.4065 6.5236L27.543 7.5001H26.598ZM24.0535 7.5001V3.0271H24.9495V5.4561L24.9565 5.7956V7.5001H24.0535Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                            <path
                                                                              d="M21.4314 7.60162C20.8131 7.60162 20.3453 7.44062 20.0279 7.11862C19.7129 6.79428 19.5554 6.33112 19.5554 5.72912V4.81912C19.5554 4.21478 19.7129 3.74928 20.0279 3.42262C20.3453 3.09595 20.8131 2.93262 21.4314 2.93262C22.0498 2.93262 22.5164 3.09595 22.8314 3.42262C23.1488 3.74928 23.3074 4.21478 23.3074 4.81912V5.72912C23.3074 6.33112 23.1499 6.79428 22.8349 7.11862C22.5199 7.44062 22.0521 7.60162 21.4314 7.60162ZM21.4314 6.83862C21.7464 6.83862 21.9821 6.74528 22.1384 6.55862C22.2948 6.37195 22.3729 6.10945 22.3729 5.77112V4.77712C22.3729 4.42712 22.2948 4.15878 22.1384 3.97212C21.9821 3.78312 21.7464 3.68862 21.4314 3.68862C21.1188 3.68862 20.8843 3.78312 20.7279 3.97212C20.5716 4.15878 20.4934 4.42712 20.4934 4.77712V5.77112C20.4934 6.10945 20.5716 6.37195 20.7279 6.55862C20.8843 6.74528 21.1188 6.83862 21.4314 6.83862Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                            <path
                                                                              d="M16.2441 6.1561V5.4071H17.3851C17.6371 5.4071 17.8191 5.34877 17.9311 5.2321C18.0454 5.1131 18.1026 4.9416 18.1026 4.7176V4.4621C18.1026 4.23343 18.0466 4.06193 17.9346 3.9476C17.8226 3.83093 17.6406 3.7726 17.3886 3.7726H16.2441V3.0271H17.4411C17.9848 3.0271 18.3826 3.1496 18.6346 3.3946C18.8889 3.6396 19.0161 3.98727 19.0161 4.4376V4.7456C19.0161 5.19593 18.8889 5.5436 18.6346 5.7886C18.3826 6.0336 17.9848 6.1561 17.4411 6.1561H16.2441ZM15.6316 7.5001V3.0271H16.5346V5.6206L16.5381 6.0371V7.5001H15.6316Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                            <path
                                                                              d="M13.2396 7.59104C13.032 7.59104 12.8371 7.57587 12.6551 7.54554C12.4755 7.5152 12.3121 7.47787 12.1651 7.43354C12.0205 7.38687 11.8956 7.3402 11.7906 7.29354L11.7101 6.42554C11.8921 6.5212 12.108 6.60754 12.3576 6.68454C12.6073 6.7592 12.8733 6.79654 13.1556 6.79654C13.4543 6.79654 13.6701 6.75337 13.8031 6.66704C13.9361 6.5807 14.0026 6.4477 14.0026 6.26804V6.22954C14.0026 6.11287 13.9735 6.0172 13.9151 5.94254C13.8591 5.86554 13.7646 5.79787 13.6316 5.73954C13.4986 5.6812 13.3178 5.6217 13.0891 5.56104C12.7671 5.47237 12.5023 5.37204 12.2946 5.26004C12.0893 5.1457 11.9376 5.00454 11.8396 4.83654C11.7416 4.6662 11.6926 4.4527 11.6926 4.19604V4.15404C11.6926 3.76204 11.8245 3.46104 12.0881 3.25103C12.3541 3.04104 12.7461 2.93604 13.2641 2.93604C13.5861 2.93604 13.8626 2.9652 14.0936 3.02354C14.3246 3.08187 14.5183 3.14954 14.6746 3.22654L14.7551 4.03504C14.5801 3.9417 14.3795 3.8647 14.1531 3.80404C13.9291 3.74104 13.6841 3.70954 13.4181 3.70954C13.2198 3.70954 13.0623 3.7282 12.9456 3.76554C12.8313 3.80287 12.7485 3.8577 12.6971 3.93003C12.6481 4.00237 12.6236 4.08987 12.6236 4.19254V4.20304C12.6236 4.30804 12.6493 4.39904 12.7006 4.47604C12.7543 4.55304 12.8488 4.6242 12.9841 4.68954C13.1195 4.75254 13.312 4.81787 13.5616 4.88554C13.879 4.9742 14.138 5.06987 14.3386 5.17254C14.5416 5.2752 14.6921 5.4082 14.7901 5.57154C14.8881 5.73487 14.9371 5.9507 14.9371 6.21904V6.28204C14.9371 6.7137 14.796 7.04037 14.5136 7.26204C14.2336 7.48137 13.809 7.59104 13.2396 7.59104Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                            <path
                                                                              fill-rule="evenodd"
                                                                              clip-rule="evenodd"
                                                                              d="M1 1H10H33V9H10H1V1ZM0 0H1H33H34V1V9V10H33H1H0V9V1V0Z"
                                                                              fill="#D15BE4"
                                                                            ></path>
                                                                          </g>
                                                                          <defs>
                                                                            <clipPath id="clip0_3432_39516">
                                                                              <rect
                                                                                width="34"
                                                                                height="10"
                                                                                rx="1"
                                                                                fill="white"
                                                                              ></rect>
                                                                            </clipPath>
                                                                            <clipPath id="clip1_3432_39516">
                                                                              <rect
                                                                                width="8"
                                                                                height="6"
                                                                                fill="white"
                                                                                transform="translate(1 2)"
                                                                              ></rect>
                                                                            </clipPath>
                                                                          </defs>
                                                                        </svg>
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                  {item.inPlay && (
                                                                    <span className="in-play ms-1 in-play">
                                                                      In-play
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )} */}
                                                              <span
                                                                className="match-name"
                                                                onClick={() => {
                                                                  localStorage.setItem(
                                                                    "sportsName",
                                                                    item.eventName
                                                                  );
                                                                  localStorage.setItem(
                                                                    "sportsData",
                                                                    JSON.stringify(
                                                                      item
                                                                    )
                                                                  );
                                                                  navigate(
                                                                    `/multimarket/${item.gameId}/${item.marketId}`
                                                                  );
                                                                }}
                                                              >
                                                                {item.eventName}
                                                              </span>
                                                              {dropDownOption !==
                                                                "by Competition" && (
                                                                  <div className="icon-sports d-flex align-items-center">
                                                                    <div className="in-play">
                                                                      In-play
                                                                    </div>
                                                                    {item.inPlay && <img src={Streaming} alt="streaming" />}
                                                                    {(item.f && !parlyActive) && <img src={fancybet} alt="fancybet" />}
                                                                    {(item.m1 && !parlyActive) && <img src={bookmaker} alt="bookmaker" />}
                                                                  </div>
                                                                )}
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                              <div className="counter">
                                                                0 - 0
                                                              </div>
                                                              <button
                                                                type="button"
                                                                className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                                                onClick={(
                                                                  e
                                                                ) => {
                                                                  clickOnScoreBoard(
                                                                    e,
                                                                    `soccer_${item?.gameId}`
                                                                  );
                                                                }}
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#fe9f00"
                                                                  width="1em"
                                                                  height="1em"
                                                                  viewBox="0 0 256 256"
                                                                  strokeWidth="0"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z" />
                                                                </svg>
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                                              >
                                                                <svg
                                                                  stroke="currentColor"
                                                                  fill="#fe9f00"
                                                                  strokeWidth="0"
                                                                  viewBox="0 0 256 512"
                                                                  height="1em"
                                                                  width="1em"
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                  <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                                                                </svg>
                                                              </button>
                                                            </div>
                                                          </div>
                                                          {!parlyActive &&
                                                            dropDownOption ===
                                                            "by Competition" && (
                                                              <div className="sports-team-table">
                                                                <div className="match-odd-table p-3 px-0 py-1">
                                                                  <div className="d-flex back-lay-head justify-content-end ms-auto pb-1 w-100">
                                                                    <div className="half-table">
                                                                      <div className="h-icon">
                                                                        {item.inPlay && <img src={Streaming} alt="streaming" />}
                                                                        {(item.f && !parlyActive) && <img src={fancybet} alt="fancybet" />}
                                                                        {(item.m1 && !parlyActive) && <img src={bookmaker} alt="bookmaker" />}
                                                                        <div className="in-play">
                                                                          In-play
                                                                        </div>
                                                                      </div>
                                                                      {/* <strong className="px-2">27,111,747.02</strong> */}
                                                                    </div>
                                                                    <span
                                                                      className="text-center half-table-text"
                                                                      style={{
                                                                        width:
                                                                          "64px",
                                                                      }}
                                                                    >
                                                                      Back
                                                                    </span>
                                                                    <span
                                                                      className="text-center half-table-text"
                                                                      style={{
                                                                        width:
                                                                          "64px",
                                                                      }}
                                                                    >
                                                                      Lay
                                                                    </span>
                                                                  </div>
                                                                  <ul className="mb-0 rounded position-relative p-0">
                                                                    <li>
                                                                      <h2>
                                                                        {
                                                                          item?.eventName?.split(
                                                                            " v "
                                                                          )[0]
                                                                        }{" "}
                                                                      </h2>
                                                                      <div className="lay-back-table ">
                                                                        <div
                                                                          id="back_odds_0"
                                                                          className="back"
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.back1
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                        <div
                                                                          title="32-152.14"
                                                                          id="lay_odds_0"
                                                                          className="lay  "
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.lay1
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </li>
                                                                    <li>
                                                                      <h2>
                                                                        {
                                                                          item?.eventName?.split(
                                                                            " v "
                                                                          )[1]
                                                                        }{" "}
                                                                      </h2>
                                                                      <div className="lay-back-table ">
                                                                        <div
                                                                          title="1.03-87868.13"
                                                                          id="back_odds_0"
                                                                          className="back spark-back "
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.back2
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                        <div
                                                                          id="lay_odds_0"
                                                                          className="lay spark-lay "
                                                                        >
                                                                          <span className="">
                                                                            <strong>
                                                                              {
                                                                                item.lay2
                                                                              }
                                                                            </strong>
                                                                            <span className="d-block">
                                                                              {Math.floor(
                                                                                Math.random() *
                                                                                10
                                                                              )}
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </li>

                                                                    {item?.RunnersNumber >
                                                                      2 && (
                                                                        <>
                                                                          <li>
                                                                            <h2>
                                                                              {" "}
                                                                              The
                                                                              Draw{" "}
                                                                            </h2>
                                                                            <div className="lay-back-table ">
                                                                              <div
                                                                                title="1.03-87868.13"
                                                                                id="back_odds_0"
                                                                                className="back spark-back "
                                                                              >
                                                                                <span className="">
                                                                                  <strong>
                                                                                    {
                                                                                      item.back3
                                                                                    }
                                                                                  </strong>
                                                                                  <span className="d-block">
                                                                                    {Math.floor(
                                                                                      Math.random() *
                                                                                      10
                                                                                    )}
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                              <div
                                                                                id="lay_odds_0"
                                                                                className="lay spark-lay "
                                                                              >
                                                                                <span className="">
                                                                                  <strong>
                                                                                    {
                                                                                      item.lay3
                                                                                    }
                                                                                  </strong>
                                                                                  <span className="d-block">
                                                                                    {Math.floor(
                                                                                      Math.random() *
                                                                                      10
                                                                                    )}
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          </li>
                                                                        </>
                                                                      )}
                                                                  </ul>
                                                                </div>
                                                              </div>
                                                            )}
                                                          {activeAccordionsChart.includes(
                                                            `soccer_${item?.gameId}`
                                                          ) &&
                                                            activeAccordionsChartIds[
                                                            item?.gameId
                                                            ] && (
                                                              <iframe
                                                                title="chart-cricte"
                                                                src={`https://www.satsports.net/score_widget/index.html?id=${activeAccordionsChartIds[
                                                                  item?.gameId
                                                                ]
                                                                  }&amp;aC=bGFzZXJib29rMjQ3`}
                                                                // src={`https://www.satsports.net/score_widget/index.html?id=53176937&amp;aC=bGFzZXJib29rMjQ3`}
                                                                width="100%"
                                                              ></iframe>
                                                            )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          ) : isLoading ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                style={{ width: 100 }}
                                src={LoaderImage}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="no-deta">
                              <div className="no-box">
                                <FontAwesomeIcon icon={faFile} />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    categoryActive !== "all" && (
                      <div className="no-deta">
                        <div className="no-box">
                          <FontAwesomeIcon icon={faFile} />
                        </div>
                      </div>
                    )
                  )
                ) : (
                  ""
                )}

                {/* for tenis */}
                {categoryActive === "all" || categoryActive === "tennis" ? (
                  isLoading || pageData?.tennis?.length > 0 ? (
                    <>
                      {pageData &&
                        dropDownOption === "by Time1" &&
                        !isLoading &&
                        pageData.tennis.length > 0 ? (
                        <>
                          <div className="custom-inplay">
                            <div
                              className="matchlist-heading"
                              style={{ backgroundColor: "black" }}
                            >
                              <h6
                                className="sports-heading mb-0"
                                style={{ color: "white", borderColor: "white" }}
                              >
                                Tennis
                              </h6>
                            </div>
                            {pageData?.tennis?.map((sport, i) => {
                              return (
                                <>
                                  <div className="sport-accord-body-wrp" onClick={() => openDetailPage(sport)}>
                                    <div
                                      className="inplay-box"
                                      data-is-today-type={tab === "today"}
                                      data-is-tomorrow-type={tab === "tomorrow"}
                                      data-is-inplay-type={tab === "play"}
                                    >
                                      <div className="inplay text-center">
                                        {/* Today 22:30 */}
                                        {tab === "play"
                                          ? "In-Play"
                                          : tab === "today"
                                            ? "Today " +
                                            moment(sport?.openDate).format(
                                              "HH:mm"
                                            )
                                            : moment(sport?.openDate).format(
                                              "MMM DD HH:mm"
                                            )}
                                      </div>
                                    </div>
                                    <div className="fave bg-star-sprit-black"></div>
                                    <div className="pe-4 py-2">
                                      <span className="match-name">
                                        {sport.eventName}
                                      </span>
                                      <div className="icon-sports d-flex align-items-center">
                                        <div>
                                          {sport.inPlay && (
                                            <img src={YoutubeImage} alt="" />
                                          )}
                                          {sport.f && !parlyActive && (
                                            <img src={FImage} alt="" />
                                          )}
                                          {sport.m1 && !parlyActive && (
                                            <img src={BImage} alt="" />
                                          )}
                                          {!parlyActive && (
                                            <img src={SImage} alt="" />
                                          )}
                                          {sport?.ematch > 0 && (
                                            <div
                                              style={{
                                                width: "2.4285714285714284rem",
                                                height: "2.669vw",
                                              }}
                                            >
                                              <svg
                                                width="100%"
                                                height="100%"
                                                viewBox="0 0 34 10"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clip-path="url(#clip0_3432_39516)">
                                                  <path
                                                    d="M9.165 0C9.625 0 10 0.374167 10 0.835V9.165C10 9.625 9.62583 10 9.165 10H0.835C0.725346 10 0.616766 9.9784 0.515459 9.93644C0.414152 9.89448 0.322103 9.83297 0.244566 9.75543C0.167029 9.6779 0.105523 9.58585 0.0635606 9.48454C0.0215979 9.38323 0 9.27465 0 9.165L0 0.835C0 0.375 0.374167 0 0.835 0H9.165Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <g clip-path="url(#clip1_3432_39516)">
                                                    <path
                                                      d="M8.571 3.76974L9.00005 2.54541H3.04486C2.74453 2.54541 2.47852 2.72396 2.38413 2.99603L1.28577 6.09086H3.39668L3.57688 5.58923H7.4469L7.8073 4.56045H3.93728L4.22046 3.76974H8.571Z"
                                                      fill="white"
                                                    ></path>
                                                    <path
                                                      d="M3.26438 6.36353H1.16192L1.03425 6.69686C0.889542 7.06807 1.22151 7.45443 1.68967 7.45443H7.14583L7.57143 6.36353H3.25587H3.26438Z"
                                                      fill="white"
                                                    ></path>
                                                  </g>
                                                  <path
                                                    d="M29.16 7.5001V3.1986H30.0805V7.5001H29.16ZM27.886 3.7936V3.0271H31.3475V3.7936H27.886Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M26.598 7.5001L26.4965 6.6286C26.4801 6.47227 26.4475 6.3416 26.3985 6.2366C26.3495 6.1316 26.276 6.05227 26.178 5.9986C26.08 5.9426 25.9446 5.9146 25.772 5.9146L24.6905 5.9111V5.2041L25.828 5.2006C26.0823 5.2006 26.2643 5.14227 26.374 5.0256C26.486 4.9066 26.542 4.73743 26.542 4.5181V4.4341C26.542 4.2171 26.486 4.0526 26.374 3.9406C26.2643 3.82627 26.08 3.7691 25.821 3.7691H24.68V3.0271H25.9505C26.4755 3.0271 26.8581 3.13327 27.0985 3.3456C27.3411 3.55793 27.4625 3.8601 27.4625 4.2521V4.3501C27.4625 4.6441 27.3913 4.87743 27.249 5.0501C27.1066 5.22277 26.8803 5.32543 26.57 5.3581V5.4841L26.3145 5.3581C26.5805 5.37677 26.7858 5.43277 26.9305 5.5261C27.0775 5.61943 27.1848 5.74893 27.2525 5.9146C27.3201 6.07793 27.3715 6.28093 27.4065 6.5236L27.543 7.5001H26.598ZM24.0535 7.5001V3.0271H24.9495V5.4561L24.9565 5.7956V7.5001H24.0535Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M21.4314 7.60162C20.8131 7.60162 20.3453 7.44062 20.0279 7.11862C19.7129 6.79428 19.5554 6.33112 19.5554 5.72912V4.81912C19.5554 4.21478 19.7129 3.74928 20.0279 3.42262C20.3453 3.09595 20.8131 2.93262 21.4314 2.93262C22.0498 2.93262 22.5164 3.09595 22.8314 3.42262C23.1488 3.74928 23.3074 4.21478 23.3074 4.81912V5.72912C23.3074 6.33112 23.1499 6.79428 22.8349 7.11862C22.5199 7.44062 22.0521 7.60162 21.4314 7.60162ZM21.4314 6.83862C21.7464 6.83862 21.9821 6.74528 22.1384 6.55862C22.2948 6.37195 22.3729 6.10945 22.3729 5.77112V4.77712C22.3729 4.42712 22.2948 4.15878 22.1384 3.97212C21.9821 3.78312 21.7464 3.68862 21.4314 3.68862C21.1188 3.68862 20.8843 3.78312 20.7279 3.97212C20.5716 4.15878 20.4934 4.42712 20.4934 4.77712V5.77112C20.4934 6.10945 20.5716 6.37195 20.7279 6.55862C20.8843 6.74528 21.1188 6.83862 21.4314 6.83862Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M16.2441 6.1561V5.4071H17.3851C17.6371 5.4071 17.8191 5.34877 17.9311 5.2321C18.0454 5.1131 18.1026 4.9416 18.1026 4.7176V4.4621C18.1026 4.23343 18.0466 4.06193 17.9346 3.9476C17.8226 3.83093 17.6406 3.7726 17.3886 3.7726H16.2441V3.0271H17.4411C17.9848 3.0271 18.3826 3.1496 18.6346 3.3946C18.8889 3.6396 19.0161 3.98727 19.0161 4.4376V4.7456C19.0161 5.19593 18.8889 5.5436 18.6346 5.7886C18.3826 6.0336 17.9848 6.1561 17.4411 6.1561H16.2441ZM15.6316 7.5001V3.0271H16.5346V5.6206L16.5381 6.0371V7.5001H15.6316Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    d="M13.2396 7.59104C13.032 7.59104 12.8371 7.57587 12.6551 7.54554C12.4755 7.5152 12.3121 7.47787 12.1651 7.43354C12.0205 7.38687 11.8956 7.3402 11.7906 7.29354L11.7101 6.42554C11.8921 6.5212 12.108 6.60754 12.3576 6.68454C12.6073 6.7592 12.8733 6.79654 13.1556 6.79654C13.4543 6.79654 13.6701 6.75337 13.8031 6.66704C13.9361 6.5807 14.0026 6.4477 14.0026 6.26804V6.22954C14.0026 6.11287 13.9735 6.0172 13.9151 5.94254C13.8591 5.86554 13.7646 5.79787 13.6316 5.73954C13.4986 5.6812 13.3178 5.6217 13.0891 5.56104C12.7671 5.47237 12.5023 5.37204 12.2946 5.26004C12.0893 5.1457 11.9376 5.00454 11.8396 4.83654C11.7416 4.6662 11.6926 4.4527 11.6926 4.19604V4.15404C11.6926 3.76204 11.8245 3.46104 12.0881 3.25103C12.3541 3.04104 12.7461 2.93604 13.2641 2.93604C13.5861 2.93604 13.8626 2.9652 14.0936 3.02354C14.3246 3.08187 14.5183 3.14954 14.6746 3.22654L14.7551 4.03504C14.5801 3.9417 14.3795 3.8647 14.1531 3.80404C13.9291 3.74104 13.6841 3.70954 13.4181 3.70954C13.2198 3.70954 13.0623 3.7282 12.9456 3.76554C12.8313 3.80287 12.7485 3.8577 12.6971 3.93003C12.6481 4.00237 12.6236 4.08987 12.6236 4.19254V4.20304C12.6236 4.30804 12.6493 4.39904 12.7006 4.47604C12.7543 4.55304 12.8488 4.6242 12.9841 4.68954C13.1195 4.75254 13.312 4.81787 13.5616 4.88554C13.879 4.9742 14.138 5.06987 14.3386 5.17254C14.5416 5.2752 14.6921 5.4082 14.7901 5.57154C14.8881 5.73487 14.9371 5.9507 14.9371 6.21904V6.28204C14.9371 6.7137 14.796 7.04037 14.5136 7.26204C14.2336 7.48137 13.809 7.59104 13.2396 7.59104Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                  <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M1 1H10H33V9H10H1V1ZM0 0H1H33H34V1V9V10H33H1H0V9V1V0Z"
                                                    fill="#D15BE4"
                                                  ></path>
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_3432_39516">
                                                    <rect
                                                      width="34"
                                                      height="10"
                                                      rx="1"
                                                      fill="white"
                                                    ></rect>
                                                  </clipPath>
                                                  <clipPath id="clip1_3432_39516">
                                                    <rect
                                                      width="8"
                                                      height="6"
                                                      fill="white"
                                                      transform="translate(1 2)"
                                                    ></rect>
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </div>
                                          )}
                                        </div>
                                        {/* <span class="inplay ms-1 in-play">In-play</span> */}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <div class="counter">0 - 0</div>
                                      <button
                                        type="button"
                                        className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                        onClick={(e) => {
                                          clickOnScoreBoard(
                                            e,
                                            `tennis_${sport?.gameId}`
                                          );
                                        }}
                                      >
                                        <svg
                                          stroke="currentColor"
                                          fill="#fe9f00"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 256 256"
                                          strokeWidth="0"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        class="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                      >
                                        <svg
                                          stroke="currentColor"
                                          fill="#fe9f00"
                                          stroke-width="0"
                                          viewBox="0 0 256 512"
                                          height="1em"
                                          width="1em"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                  {activeAccordionsChart.includes(
                                    `tennis_${sport?.gameId}`
                                  ) &&
                                    activeAccordionsChartIds[sport?.gameId] && (
                                      <iframe
                                        title="chart-cricte"
                                        src={`https://www.satsports.net/score_widget/index.html?id=${activeAccordionsChartIds[
                                          sport?.gameId
                                        ]
                                          }&amp;aC=bGFzZXJib29rMjQ3`}
                                        // src={`https://www.satsports.net/score_widget/index.html?id=53176937&amp;aC=bGFzZXJib29rMjQ3`}
                                        width="100%"
                                      ></iframe>
                                    )}
                                </>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        <div className="bg-skylight matchlist">
                          <div>
                            <div
                              className="matchlist-heading"

                            >
                              <h6 className="sports-heading mb-0">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M246.938 35.188c-25.875 1.07-51.58 6.686-75.5 16.593-26.714 11.065-51.274 27.462-71.72 47.907-20.445 20.446-36.84 45.005-47.906 71.72-9.8 23.662-15.405 49.065-16.562 74.655 74.49-11.465 126.867-33.367 160.656-67.156 33.846-33.845 50.15-80.167 51.03-143.72zm18 0c-.91 66.75-18.61 118.764-56.313 156.468-38.05 38.05-95.324 60.96-173.438 72.625 1 26.133 6.65 52.13 16.657 76.283 11.067 26.715 27.458 51.24 47.906 71.687 20.448 20.448 45.003 36.87 71.72 47.938 24.152 10.005 50.122 15.63 76.25 16.625 11.665-78.115 34.575-135.39 72.624-173.438 37.704-37.704 89.72-55.402 156.47-56.313-1.06-25.916-6.67-51.663-16.595-75.625-11.068-26.715-27.49-51.27-47.94-71.718-20.447-20.45-44.97-36.84-71.686-47.907-23.96-9.927-49.735-15.56-75.656-16.626zm211.187 229.875c-63.202.987-109.34 17.307-143.063 51.03-33.793 33.795-55.662 86.15-67.125 160.657 25.596-1.157 51.026-6.762 74.688-16.563 26.714-11.064 51.242-27.46 71.688-47.906 20.445-20.444 36.842-44.972 47.906-71.686 9.906-23.922 15.522-49.652 16.592-75.53-.228.002-.46-.005-.687-.002z"></path></svg> Tennis
                              </h6>
                              {dropDownOption === "by Competition" && (
                                <div
                                  className={`all-complete-all ${categoryState.tennis ? "active" : ""
                                    }`}
                                  onClick={() => handleClick("tennis")}
                                >
                                  <span className="mr-1">ALL</span>
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 24 24"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path d="M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path>
                                    <path d="M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path>
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>

                          {pageData &&
                            allTurnaments &&
                            !isLoading &&
                            pageData.tennis.length > 0 ? (
                            <>
                              {allTurnaments?.tennis
                                ?.sort(customSort)
                                .map((sport, i) => {
                                  return (
                                    <>
                                      <div className="bookmaker-wrp">
                                        <div className="bookmaker p-sm-2 sport-accordian">
                                          <div className="accordion">
                                            <div className="accordion-item">
                                              {dropDownOption ===
                                                "by Competition" && (
                                                  <h2
                                                    className={`accordion-header ${activeAccordions.includes(
                                                      `tennis_${sport}`
                                                    ) ||
                                                      activeAccordions.includes(
                                                        "tennis_all"
                                                      ) ||
                                                      dropDownOption !==
                                                      "by Competition"
                                                      ? "active"
                                                      : ""
                                                      }`}
                                                    onClick={() =>
                                                      toggleAccordion(
                                                        `tennis_${sport}`
                                                      )
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      aria-expanded="true"
                                                      className="accordion-button"
                                                    >
                                                      <span className="flex-grow-1">
                                                        {" "}
                                                        {sport ? sport : "other"}
                                                      </span>
                                                      <span className="sport-counter bg-yellow ">
                                                        {
                                                          pageData.tennis.filter(
                                                            (_) =>
                                                              _.Turnament ===
                                                              sport
                                                          ).length
                                                        }
                                                      </span>
                                                    </button>
                                                  </h2>
                                                )}
                                              {pageData.tennis
                                                .filter(
                                                  (_) => _.Turnament === sport
                                                )
                                                .map((item, i) => {
                                                  return (
                                                    <div
                                                      onClick={() => {
                                                        localStorage.setItem(
                                                          "sportsName",
                                                          item.eventName
                                                        );
                                                        localStorage.setItem(
                                                          "sportsData",
                                                          JSON.stringify(item)
                                                        );
                                                        navigate(
                                                          `/multimarket/${item.gameId}/${item.marketId}`
                                                        );
                                                      }}
                                                      className={`accordion-collapse collapse ${activeAccordions.includes(
                                                        `tennis_${sport}`
                                                      ) ||
                                                        activeAccordions.includes(
                                                          "tennis_all"
                                                        ) ||
                                                        dropDownOption !==
                                                        "by Competition"
                                                        ? "slide-down show"
                                                        : "slide-up"
                                                        }`}
                                                    >
                                                      <div className="p-0 py-1 px-sm-3 px-2 accordion-body">
                                                        <div className="sport-accord-body">
                                                          <div className="">
                                                            <div className="sport-accord-body-wrp" onClick={() => openDetailPage(sport)}>
                                                              {!parlyActive && (
                                                                <div className="fave bg-star-sprit-black position-absolute start-0"></div>
                                                              )}
                                                              <div
                                                                className={`${!parlyActive
                                                                  ? "ps-4"
                                                                  : ""
                                                                  }`}
                                                              >
                                                                {/* {dropDownOption ===
                                                                  "by Competition" && (
                                                                  <div className="icon-sports d-flex align-items-center">
                                                                    <div>
                                                                      {item.inPlay && (
                                                                        <img
                                                                          src={
                                                                            YoutubeImage
                                                                          }
                                                                          alt=""
                                                                        />
                                                                      )}
                                                                      {item.f &&
                                                                        !parlyActive && (
                                                                          <img
                                                                            src={
                                                                              FImage
                                                                            }
                                                                            alt=""
                                                                          />
                                                                        )}
                                                                      {item.m1 &&
                                                                        !parlyActive && (
                                                                          <img
                                                                            src={
                                                                              BImage
                                                                            }
                                                                            alt=""
                                                                          />
                                                                        )}
                                                                      {!parlyActive && (
                                                                        <img
                                                                          src={
                                                                            SImage
                                                                          }
                                                                          alt=""
                                                                        />
                                                                      )}
                                                                      {item?.ematch >
                                                                        0 && (
                                                                        <div
                                                                          style={{
                                                                            width:
                                                                              "2.4285714285714284rem",
                                                                            height:
                                                                              "2.669vw",
                                                                          }}
                                                                        >
                                                                          <svg
                                                                            width="100%"
                                                                            height="100%"
                                                                            viewBox="0 0 34 10"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                          >
                                                                            <g clip-path="url(#clip0_3432_39516)">
                                                                              <path
                                                                                d="M9.165 0C9.625 0 10 0.374167 10 0.835V9.165C10 9.625 9.62583 10 9.165 10H0.835C0.725346 10 0.616766 9.9784 0.515459 9.93644C0.414152 9.89448 0.322103 9.83297 0.244566 9.75543C0.167029 9.6779 0.105523 9.58585 0.0635606 9.48454C0.0215979 9.38323 0 9.27465 0 9.165L0 0.835C0 0.375 0.374167 0 0.835 0H9.165Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                              <g clip-path="url(#clip1_3432_39516)">
                                                                                <path
                                                                                  d="M8.571 3.76974L9.00005 2.54541H3.04486C2.74453 2.54541 2.47852 2.72396 2.38413 2.99603L1.28577 6.09086H3.39668L3.57688 5.58923H7.4469L7.8073 4.56045H3.93728L4.22046 3.76974H8.571Z"
                                                                                  fill="white"
                                                                                ></path>
                                                                                <path
                                                                                  d="M3.26438 6.36353H1.16192L1.03425 6.69686C0.889542 7.06807 1.22151 7.45443 1.68967 7.45443H7.14583L7.57143 6.36353H3.25587H3.26438Z"
                                                                                  fill="white"
                                                                                ></path>
                                                                              </g>
                                                                              <path
                                                                                d="M29.16 7.5001V3.1986H30.0805V7.5001H29.16ZM27.886 3.7936V3.0271H31.3475V3.7936H27.886Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                              <path
                                                                                d="M26.598 7.5001L26.4965 6.6286C26.4801 6.47227 26.4475 6.3416 26.3985 6.2366C26.3495 6.1316 26.276 6.05227 26.178 5.9986C26.08 5.9426 25.9446 5.9146 25.772 5.9146L24.6905 5.9111V5.2041L25.828 5.2006C26.0823 5.2006 26.2643 5.14227 26.374 5.0256C26.486 4.9066 26.542 4.73743 26.542 4.5181V4.4341C26.542 4.2171 26.486 4.0526 26.374 3.9406C26.2643 3.82627 26.08 3.7691 25.821 3.7691H24.68V3.0271H25.9505C26.4755 3.0271 26.8581 3.13327 27.0985 3.3456C27.3411 3.55793 27.4625 3.8601 27.4625 4.2521V4.3501C27.4625 4.6441 27.3913 4.87743 27.249 5.0501C27.1066 5.22277 26.8803 5.32543 26.57 5.3581V5.4841L26.3145 5.3581C26.5805 5.37677 26.7858 5.43277 26.9305 5.5261C27.0775 5.61943 27.1848 5.74893 27.2525 5.9146C27.3201 6.07793 27.3715 6.28093 27.4065 6.5236L27.543 7.5001H26.598ZM24.0535 7.5001V3.0271H24.9495V5.4561L24.9565 5.7956V7.5001H24.0535Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                              <path
                                                                                d="M21.4314 7.60162C20.8131 7.60162 20.3453 7.44062 20.0279 7.11862C19.7129 6.79428 19.5554 6.33112 19.5554 5.72912V4.81912C19.5554 4.21478 19.7129 3.74928 20.0279 3.42262C20.3453 3.09595 20.8131 2.93262 21.4314 2.93262C22.0498 2.93262 22.5164 3.09595 22.8314 3.42262C23.1488 3.74928 23.3074 4.21478 23.3074 4.81912V5.72912C23.3074 6.33112 23.1499 6.79428 22.8349 7.11862C22.5199 7.44062 22.0521 7.60162 21.4314 7.60162ZM21.4314 6.83862C21.7464 6.83862 21.9821 6.74528 22.1384 6.55862C22.2948 6.37195 22.3729 6.10945 22.3729 5.77112V4.77712C22.3729 4.42712 22.2948 4.15878 22.1384 3.97212C21.9821 3.78312 21.7464 3.68862 21.4314 3.68862C21.1188 3.68862 20.8843 3.78312 20.7279 3.97212C20.5716 4.15878 20.4934 4.42712 20.4934 4.77712V5.77112C20.4934 6.10945 20.5716 6.37195 20.7279 6.55862C20.8843 6.74528 21.1188 6.83862 21.4314 6.83862Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                              <path
                                                                                d="M16.2441 6.1561V5.4071H17.3851C17.6371 5.4071 17.8191 5.34877 17.9311 5.2321C18.0454 5.1131 18.1026 4.9416 18.1026 4.7176V4.4621C18.1026 4.23343 18.0466 4.06193 17.9346 3.9476C17.8226 3.83093 17.6406 3.7726 17.3886 3.7726H16.2441V3.0271H17.4411C17.9848 3.0271 18.3826 3.1496 18.6346 3.3946C18.8889 3.6396 19.0161 3.98727 19.0161 4.4376V4.7456C19.0161 5.19593 18.8889 5.5436 18.6346 5.7886C18.3826 6.0336 17.9848 6.1561 17.4411 6.1561H16.2441ZM15.6316 7.5001V3.0271H16.5346V5.6206L16.5381 6.0371V7.5001H15.6316Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                              <path
                                                                                d="M13.2396 7.59104C13.032 7.59104 12.8371 7.57587 12.6551 7.54554C12.4755 7.5152 12.3121 7.47787 12.1651 7.43354C12.0205 7.38687 11.8956 7.3402 11.7906 7.29354L11.7101 6.42554C11.8921 6.5212 12.108 6.60754 12.3576 6.68454C12.6073 6.7592 12.8733 6.79654 13.1556 6.79654C13.4543 6.79654 13.6701 6.75337 13.8031 6.66704C13.9361 6.5807 14.0026 6.4477 14.0026 6.26804V6.22954C14.0026 6.11287 13.9735 6.0172 13.9151 5.94254C13.8591 5.86554 13.7646 5.79787 13.6316 5.73954C13.4986 5.6812 13.3178 5.6217 13.0891 5.56104C12.7671 5.47237 12.5023 5.37204 12.2946 5.26004C12.0893 5.1457 11.9376 5.00454 11.8396 4.83654C11.7416 4.6662 11.6926 4.4527 11.6926 4.19604V4.15404C11.6926 3.76204 11.8245 3.46104 12.0881 3.25103C12.3541 3.04104 12.7461 2.93604 13.2641 2.93604C13.5861 2.93604 13.8626 2.9652 14.0936 3.02354C14.3246 3.08187 14.5183 3.14954 14.6746 3.22654L14.7551 4.03504C14.5801 3.9417 14.3795 3.8647 14.1531 3.80404C13.9291 3.74104 13.6841 3.70954 13.4181 3.70954C13.2198 3.70954 13.0623 3.7282 12.9456 3.76554C12.8313 3.80287 12.7485 3.8577 12.6971 3.93003C12.6481 4.00237 12.6236 4.08987 12.6236 4.19254V4.20304C12.6236 4.30804 12.6493 4.39904 12.7006 4.47604C12.7543 4.55304 12.8488 4.6242 12.9841 4.68954C13.1195 4.75254 13.312 4.81787 13.5616 4.88554C13.879 4.9742 14.138 5.06987 14.3386 5.17254C14.5416 5.2752 14.6921 5.4082 14.7901 5.57154C14.8881 5.73487 14.9371 5.9507 14.9371 6.21904V6.28204C14.9371 6.7137 14.796 7.04037 14.5136 7.26204C14.2336 7.48137 13.809 7.59104 13.2396 7.59104Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                              <path
                                                                                fill-rule="evenodd"
                                                                                clip-rule="evenodd"
                                                                                d="M1 1H10H33V9H10H1V1ZM0 0H1H33H34V1V9V10H33H1H0V9V1V0Z"
                                                                                fill="#D15BE4"
                                                                              ></path>
                                                                            </g>
                                                                            <defs>
                                                                              <clipPath id="clip0_3432_39516">
                                                                                <rect
                                                                                  width="34"
                                                                                  height="10"
                                                                                  rx="1"
                                                                                  fill="white"
                                                                                ></rect>
                                                                              </clipPath>
                                                                              <clipPath id="clip1_3432_39516">
                                                                                <rect
                                                                                  width="8"
                                                                                  height="6"
                                                                                  fill="white"
                                                                                  transform="translate(1 2)"
                                                                                ></rect>
                                                                              </clipPath>
                                                                            </defs>
                                                                          </svg>
                                                                        </div>
                                                                      )}
                                                                    </div>
                                                                    {item.inPlay && (
                                                                      <span className="in-play ms-1 in-play">
                                                                        In-play
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )} */}
                                                                <span
                                                                  className="match-name"
                                                                  onClick={() => {
                                                                    localStorage.setItem(
                                                                      "sportsName",
                                                                      item.eventName
                                                                    );
                                                                    localStorage.setItem(
                                                                      "sportsData",
                                                                      JSON.stringify(
                                                                        item
                                                                      )
                                                                    );
                                                                    navigate(
                                                                      `/multimarket/${item.gameId}/${item.marketId}`
                                                                    );
                                                                  }}
                                                                >
                                                                  {
                                                                    item.eventName
                                                                  }
                                                                </span>
                                                                {dropDownOption !==
                                                                  "by Competition" && (
                                                                    <div className="icon-sports d-flex align-items-center">
                                                                      <div className="in-play">
                                                                        In-play
                                                                      </div>
                                                                      {item.inPlay && <img src={Streaming} alt="streaming" />}
                                                                      {(item.f && !parlyActive) && <img src={fancybet} alt="fancybet" />}
                                                                      {(item.m1 && !parlyActive) && <img src={bookmaker} alt="bookmaker" />}
                                                                    </div>
                                                                  )}
                                                              </div>
                                                              <div className="d-flex align-items-center">
                                                                <div className="counter">
                                                                  0 - 0
                                                                </div>
                                                                <button
                                                                  type="button"
                                                                  className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                                                  onClick={(
                                                                    e
                                                                  ) => {
                                                                    clickOnScoreBoard(
                                                                      e,
                                                                      `tennis_${item?.gameId}`
                                                                    );
                                                                  }}
                                                                >
                                                                  <svg
                                                                    stroke="currentColor"
                                                                    fill="#fe9f00"
                                                                    width="1em"
                                                                    height="1em"
                                                                    viewBox="0 0 256 256"
                                                                    strokeWidth="0"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                  >
                                                                    <path d="M231.99951,208a8.00039,8.00039,0,0,1-8,8h-192a8.00039,8.00039,0,0,1-8-8V48a8,8,0,0,1,16,0V156.68848l50.3457-50.34571a8.00122,8.00122,0,0,1,11.31446,0l26.34277,26.34375L176.68848,84,162.34521,69.65674A8.00038,8.00038,0,0,1,168.00244,56h40a8.00039,8.00039,0,0,1,8,8v40a8.00018,8.00018,0,0,1-13.65723,5.65674L188.00244,95.314l-54.34277,54.34327a8.00122,8.00122,0,0,1-11.31446,0L96.00244,123.31348l-56.00293,56.0039V200h184A8.00039,8.00039,0,0,1,231.99951,208Z" />
                                                                  </svg>
                                                                </button>
                                                                <button
                                                                  type="button"
                                                                  className="d-flex align-items-center bg-transparent text-dark border-0 fs-4 px-2 pt-0 pe-0"
                                                                >
                                                                  <svg
                                                                    stroke="currentColor"
                                                                    fill="#fe9f00"
                                                                    strokeWidth="0"
                                                                    viewBox="0 0 256 512"
                                                                    height="1em"
                                                                    width="1em"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                  >
                                                                    <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                                                                  </svg>
                                                                </button>
                                                              </div>
                                                            </div>
                                                            {!parlyActive &&
                                                              dropDownOption ===
                                                              "by Competition" && (
                                                                <div className="sports-team-table">
                                                                  <div className="match-odd-table p-3 px-0 py-1">
                                                                    <div className="d-flex back-lay-head justify-content-end ms-auto pb-1 w-100">
                                                                      <div className="half-table">
                                                                        <div className="h-icon">
                                                                          {item.inPlay && <img src={Streaming} alt="streaming" />}
                                                                          {(item.f && !parlyActive) && <img src={fancybet} alt="fancybet" />}
                                                                          {(item.m1 && !parlyActive) && <img src={bookmaker} alt="bookmaker" />}
                                                                          <div className="in-play">
                                                                            In-play
                                                                          </div>
                                                                        </div>
                                                                        {/* <strong className="px-2">27,111,747.02</strong> */}
                                                                      </div>
                                                                      <span
                                                                        className="text-center half-table-text"
                                                                        style={{
                                                                          width:
                                                                            "64px",
                                                                        }}
                                                                      >
                                                                        Back
                                                                      </span>
                                                                      <span
                                                                        className="text-center half-table-text"
                                                                        style={{
                                                                          width:
                                                                            "64px",
                                                                        }}
                                                                      >
                                                                        Lay
                                                                      </span>
                                                                    </div>
                                                                    <ul className="mb-0 rounded position-relative p-0">
                                                                      <li>
                                                                        <h2>
                                                                          {
                                                                            item?.eventName?.split(
                                                                              " v "
                                                                            )[0]
                                                                          }{" "}
                                                                        </h2>
                                                                        <div className="lay-back-table ">
                                                                          <div
                                                                            id="back_odds_0"
                                                                            className="back"
                                                                          >
                                                                            <span className="">
                                                                              <strong>
                                                                                {
                                                                                  item.back1
                                                                                }
                                                                              </strong>
                                                                              <span className="d-block">
                                                                                {Math.floor(
                                                                                  Math.random() *
                                                                                  10
                                                                                )}
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                          <div
                                                                            title="32-152.14"
                                                                            id="lay_odds_0"
                                                                            className="lay  "
                                                                          >
                                                                            <span className="">
                                                                              <strong>
                                                                                {
                                                                                  item.lay1
                                                                                }
                                                                              </strong>
                                                                              <span className="d-block">
                                                                                {Math.floor(
                                                                                  Math.random() *
                                                                                  10
                                                                                )}
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      <li>
                                                                        <h2>
                                                                          {
                                                                            item?.eventName?.split(
                                                                              " v "
                                                                            )[1]
                                                                          }{" "}
                                                                        </h2>
                                                                        <div className="lay-back-table ">
                                                                          <div
                                                                            title="1.03-87868.13"
                                                                            id="back_odds_0"
                                                                            className="back spark-back "
                                                                          >
                                                                            <span className="">
                                                                              <strong>
                                                                                {
                                                                                  item.back2
                                                                                }
                                                                              </strong>
                                                                              <span className="d-block">
                                                                                {Math.floor(
                                                                                  Math.random() *
                                                                                  10
                                                                                )}
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                          <div
                                                                            id="lay_odds_0"
                                                                            className="lay spark-lay "
                                                                          >
                                                                            <span className="">
                                                                              <strong>
                                                                                {
                                                                                  item.lay2
                                                                                }
                                                                              </strong>
                                                                              <span className="d-block">
                                                                                {Math.floor(
                                                                                  Math.random() *
                                                                                  10
                                                                                )}
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                      {item?.RunnersNumber >
                                                                        2 && (
                                                                          <>
                                                                            <li>
                                                                              <h2>
                                                                                {" "}
                                                                                The
                                                                                Draw{" "}
                                                                              </h2>
                                                                              <div className="lay-back-table ">
                                                                                <div
                                                                                  title="1.03-87868.13"
                                                                                  id="back_odds_0"
                                                                                  className="back spark-back "
                                                                                >
                                                                                  <span className="">
                                                                                    <strong>
                                                                                      {
                                                                                        item.back3
                                                                                      }
                                                                                    </strong>
                                                                                    <span className="d-block">
                                                                                      {Math.floor(
                                                                                        Math.random() *
                                                                                        10
                                                                                      )}
                                                                                    </span>
                                                                                  </span>
                                                                                </div>
                                                                                <div
                                                                                  id="lay_odds_0"
                                                                                  className="lay spark-lay "
                                                                                >
                                                                                  <span className="">
                                                                                    <strong>
                                                                                      {
                                                                                        item.lay3
                                                                                      }
                                                                                    </strong>
                                                                                    <span className="d-block">
                                                                                      {Math.floor(
                                                                                        Math.random() *
                                                                                        10
                                                                                      )}
                                                                                    </span>
                                                                                  </span>
                                                                                </div>
                                                                              </div>
                                                                            </li>
                                                                          </>
                                                                        )}
                                                                    </ul>
                                                                  </div>
                                                                </div>
                                                              )}
                                                            {activeAccordionsChart.includes(
                                                              `tennis_${item?.gameId}`
                                                            ) &&
                                                              activeAccordionsChartIds[
                                                              item?.gameId
                                                              ] && (
                                                                <iframe
                                                                  title="chart-cricte"
                                                                  src={`https://www.satsports.net/score_widget/index.html?id=${activeAccordionsChartIds[
                                                                    item
                                                                      ?.gameId
                                                                  ]
                                                                    }&amp;aC=bGFzZXJib29rMjQ3`}
                                                                  // src={`https://www.satsports.net/score_widget/index.html?id=53176937&amp;aC=bGFzZXJib29rMjQ3`}
                                                                  width="100%"
                                                                ></iframe>
                                                              )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })}
                            </>
                          ) : isLoading ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                style={{ width: 100 }}
                                src={LoaderImage}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="no-deta">
                              <div className="no-box">
                                <FontAwesomeIcon icon={faFile} />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    categoryActive !== "all" && (
                      <div className="no-deta">
                        <div className="no-box">
                          <FontAwesomeIcon icon={faFile} />
                        </div>
                      </div>
                    )
                  )
                ) : (
                  ""
                )}
              </>
            )}
          </>
        )}

        {/* <div className="my-bet">
          <FontAwesomeIcon icon={faList} />
        </div> */}

      </div>
      <BottomFooter />
      <FooterComponent />


      {newsPopup && (
        <CommonPopup
          title={`Announcement`}
          OpenModal={newsPopup}
          closeModel={() => setNewsPopup(false)}
          customclass="newspopup"
        >
          <NewsLinePopup
            eventData={
              DD?.maintenanceMessage ? DD?.maintenanceMessage : DD?.userMessage
            }
          />{" "}
        </CommonPopup>
      )}


    </>
  );
};

export default Cricket;
